

// import React, { useState, useEffect } from 'react';
// import { Link, useParams } from "react-router-dom";
// import axios from "../../Axiosinstance";
// import {
//   Box, Button, Table, TableBody, TableCell, TableContainer,
//   TableHead, TableRow, Paper, TablePagination, Modal, TextField,
//   MenuItem, Typography, Chip, IconButton, Divider,
//   Radio, RadioGroup, FormControlLabel, FormLabel, Dialog,
//   DialogTitle, DialogContent, DialogActions, CircularProgress,
//   Alert
// } from '@mui/material';
// import AddIcon from '@mui/icons-material/Add';
// import DeleteIcon from '@mui/icons-material/Delete';
// import EditIcon from '@mui/icons-material/Edit';
// import VisibilityIcon from '@mui/icons-material/Visibility';
// import Header from '../../components/Header';
// import { CLOUDINARY_UPLOAD_PRESET, baseURL, timestamp } from '../../common';
// import { format } from 'date-fns';
// import { toast, ToastContainer } from 'react-toastify';
// import { decryptData } from '../../Axiosinstance';

// // ─────────────────────────────────────────────────────────────────
// // MCQ View Dialog — admin views assessment questions + answers
// // ─────────────────────────────────────────────────────────────────
// const MCQViewDialog = ({ open, onClose, assessment }) => {
//   const [questions, setQuestions] = useState([]);
//   const [loading, setLoading]     = useState(false);

//   useEffect(() => {
//     if (open && assessment?.id) fetchQuestions();
//   }, [open, assessment]);

//   const fetchQuestions = async () => {
//     setLoading(true);
//     try {
//       const res = await axios.get(`assessment_questions/${assessment.id}`);
//       setQuestions(res.data);
//     } catch (err) {
//       toast.error("Failed to load questions");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const typeColors = {
//     MCQ: '#1976d2', TRUE_FALSE: '#388e3c',
//     MATCH: '#7b1fa2', SHORT_ANSWER: '#f57c00'
//   };

//   const totalMarks = questions.reduce((s, q) => s + (q.marks || 0), 0);

//   return (
//     <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth
//       PaperProps={{ sx: { maxHeight: '90vh' } }}>
//       <DialogTitle sx={{ borderBottom: '1px solid #e0e0e0', pb: 2 }}>
//         <Box display="flex" justifyContent="space-between" alignItems="center">
//           <Box>
//             <Typography variant="h6" fontWeight="bold">
//               Quiz Preview — {assessment?.description}
//             </Typography>
//             <Typography variant="body2" color="textSecondary">
//               Module: {assessment?.moduleName} · {questions.length} questions · {totalMarks} marks total
//             </Typography>
//           </Box>
//           <Chip label={`${questions.length} Qs`} color="primary" />
//         </Box>
//       </DialogTitle>

//       <DialogContent sx={{ p: 3 }}>
//         {loading ? (
//           <Box display="flex" justifyContent="center" py={6}>
//             <CircularProgress />
//           </Box>
//         ) : questions.length === 0 ? (
//           <Typography textAlign="center" color="textSecondary" py={4}>
//             No questions added yet.
//           </Typography>
//         ) : (
//           questions.map((q, index) => (
//             <Box key={q.id} sx={{
//               border: `2px solid ${typeColors[q.questionType] || '#ccc'}`,
//               borderRadius: 2, p: 2.5, mb: 2, backgroundColor: '#fafafa'
//             }}>
//               <Box display="flex" justifyContent="space-between" alignItems="flex-start" mb={1}>
//                 <Box sx={{ flex: 1 }}>
//                   <Typography fontWeight="bold">
//                     Q{index + 1}. {q.questionText}
//                   </Typography>
//                   <Box display="flex" gap={1} mt={0.5}>
//                     <Chip label={q.questionType} size="small"
//                       sx={{ backgroundColor: typeColors[q.questionType], color: 'white' }} />
//                     <Chip label={`${q.marks} mark${q.marks > 1 ? 's' : ''}`}
//                       size="small" color="info" variant="outlined" />
//                   </Box>
//                 </Box>
//               </Box>

//               <Divider sx={{ mb: 1.5 }} />

//               {/* MCQ Options with correct answer highlighted */}
//               {q.questionType === 'MCQ' && (
//                 <Box>
//                   <Typography variant="caption" fontWeight="bold" color="textSecondary" mb={1} display="block">
//                     OPTIONS (✓ = correct answer)
//                   </Typography>
//                   {q.options?.map((opt, i) => (
//                     <Box key={i} display="flex" alignItems="center" gap={1} mb={0.5} sx={{
//                       backgroundColor: opt.isCorrect ? '#e8f5e9' : 'transparent',
//                       borderRadius: 1, px: 1.5, py: 0.75,
//                       border: `1px solid ${opt.isCorrect ? '#4caf50' : '#e0e0e0'}`
//                     }}>
//                       <Typography variant="body2" sx={{
//                         fontWeight: opt.isCorrect ? 'bold' : 'normal',
//                         color: opt.isCorrect ? 'success.main' : 'inherit',
//                         flex: 1
//                       }}>
//                         {opt.optionText}
//                       </Typography>
//                       {opt.isCorrect && (
//                         <Chip label="✓ Correct" size="small" color="success"
//                           sx={{ height: 20, fontSize: '0.7rem' }} />
//                       )}
//                     </Box>
//                   ))}
//                 </Box>
//               )}

//               {/* TRUE/FALSE */}
//               {q.questionType === 'TRUE_FALSE' && (
//                 <Box>
//                   <Typography variant="caption" fontWeight="bold" color="textSecondary" mb={1} display="block">
//                     CORRECT ANSWER
//                   </Typography>
//                   <Box display="flex" gap={2}>
//                     {q.options?.map((opt, i) => (
//                       <Box key={i} sx={{
//                         border: `2px solid ${opt.isCorrect ? '#4caf50' : '#e0e0e0'}`,
//                         borderRadius: 1, px: 2.5, py: 1,
//                         backgroundColor: opt.isCorrect ? '#e8f5e9' : 'transparent',
//                         minWidth: 80, textAlign: 'center'
//                       }}>
//                         <Typography fontWeight={opt.isCorrect ? 'bold' : 'normal'}>
//                           {opt.optionText}
//                           {opt.isCorrect && ' ✓'}
//                         </Typography>
//                       </Box>
//                     ))}
//                   </Box>
//                 </Box>
//               )}

//               {/* MATCH Pairs */}
//               {q.questionType === 'MATCH' && (
//                 <Box>
//                   <Typography variant="caption" fontWeight="bold" color="textSecondary" mb={1} display="block">
//                     CORRECT PAIRS
//                   </Typography>
//                   {q.matchPairs?.map((pair, pi) => (
//                     <Box key={pi} display="flex" alignItems="center" gap={2} mb={0.5} sx={{
//                       backgroundColor: '#f3e5f5', borderRadius: 1, px: 1.5, py: 0.75
//                     }}>
//                       <Typography variant="body2" fontWeight="bold" sx={{ flex: 1 }}>
//                         {pair.leftItem}
//                       </Typography>
//                       <Typography color={typeColors.MATCH} fontWeight="bold">→</Typography>
//                       <Typography variant="body2" sx={{ flex: 1, color: 'success.main', fontWeight: 'bold' }}>
//                         {pair.rightItem}
//                       </Typography>
//                     </Box>
//                   ))}
//                 </Box>
//               )}

//               {/* SHORT ANSWER */}
//               {q.questionType === 'SHORT_ANSWER' && (
//                 <Box sx={{ backgroundColor: '#fff3e0', borderRadius: 1, p: 1.5 }}>
//                   <Typography variant="body2" color={typeColors.SHORT_ANSWER}>
//                     📝 Free-text response. Graded manually by the teacher.
//                     No predefined answer — teacher reviews and enters marks.
//                   </Typography>
//                 </Box>
//               )}
//             </Box>
//           ))
//         )}
//       </DialogContent>

//       <DialogActions sx={{ p: 2 }}>
//         <Button onClick={onClose} variant="contained">Close</Button>
//       </DialogActions>
//     </Dialog>
//   );
// };

// // ─────────────────────────────────────────────────────────────────
// // FILE Edit Dialog — edit description + re-upload file only
// // ─────────────────────────────────────────────────────────────────
// const FileEditDialog = ({ open, onClose, assessment, batchData, onSaved }) => {
//   const [description, setDescription] = useState('');
//   const [newFileUrl, setNewFileUrl]    = useState('');
//   const [fileUploaded, setFileUploaded] = useState(false);
//   const [saving, setSaving]            = useState(false);

//   const CLOUDINARY_URL    = baseURL;
//   const CLOUDINARY_UPLOAD = CLOUDINARY_UPLOAD_PRESET;

//   useEffect(() => {
//     if (assessment) {
//       setDescription(assessment.description || '');
//       setNewFileUrl('');
//       setFileUploaded(false);
//     }
//   }, [assessment]);

//   const handleFileChange = async (e) => {
//     const file = e.target.files[0];
//     if (!file) return;
//     const fd = new FormData();
//     fd.append('file', file);
//     fd.append('upload_preset', CLOUDINARY_UPLOAD);
//     fd.append('public_id', `LMS/Trent/${file.name} - ${timestamp}`);
//     try {
//       const res  = await fetch(CLOUDINARY_URL, { method: 'POST', body: fd });
//       const data = await res.json();
//       if (data.secure_url) {
//         setNewFileUrl(data.secure_url);
//         setFileUploaded(true);
//         toast.success("New file uploaded");
//       }
//     } catch {
//       toast.error("File upload failed");
//     }
//   };

//   const handleSave = async () => {
//     if (!description.trim()) {
//       toast.error("Description is required");
//       return;
//     }
//     setSaving(true);
//     try {
//       const payload = {
//         batchId:        assessment.batchId,
//         moduleName:     assessment.moduleName, // not editable
//         description,
//         url:            fileUploaded ? newFileUrl : assessment.url,
//         assessmentType: 'FILE',
//       };
//       await axios.put(`trent_assessments/${assessment.id}`, payload);
//       toast.success("Assessment updated");
//       onSaved();
//       onClose();
//     } catch {
//       toast.error("Failed to update");
//     } finally {
//       setSaving(false);
//     }
//   };

//   return (
//     <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
//       <DialogTitle>
//         <Typography variant="h6" fontWeight="bold">Edit File Assessment</Typography>
//         <Typography variant="body2" color="textSecondary">
//           Module: <strong>{assessment?.moduleName}</strong> (cannot be changed)
//         </Typography>
//       </DialogTitle>

//       <DialogContent sx={{ pt: 2 }}>
//         <Alert severity="info" sx={{ mb: 2 }}>
//           You can only edit the <strong>description</strong> and optionally replace the file.
//           The module cannot be changed.
//         </Alert>

//         <TextField
//           label="Description" fullWidth multiline rows={3}
//           value={description} sx={{ mb: 2 }}
//           onChange={e => setDescription(e.target.value)}
//         />

//         <Box sx={{ border: '1px dashed #ccc', borderRadius: 1, p: 2, mb: 1 }}>
//           <Typography variant="body2" color="textSecondary" mb={1}>
//             Current file: {assessment?.url
//               ? <a href={assessment.url} target="_blank" rel="noreferrer">View current file</a>
//               : 'No file'}
//           </Typography>
//           <TextField
//             type="file" fullWidth variant="outlined"
//             InputLabelProps={{ shrink: true }}
//             label="Replace File (optional)"
//             onChange={e => {
//               const file = e.target.files[0];
//               if (file && file.size > 8 * 1024 * 1024) {
//                 e.target.value = "";
//                 alert("File size must be less than 8MB.");
//               } else {
//                 handleFileChange(e);
//               }
//             }}
//           />
//           {fileUploaded && (
//             <Typography variant="caption" color="success.main" mt={0.5} display="block">
//               ✓ New file ready to save
//             </Typography>
//           )}
//         </Box>
//       </DialogContent>

//       <DialogActions sx={{ p: 2 }}>
//         <Button onClick={onClose} variant="outlined" color="error">Cancel</Button>
//         <Button onClick={handleSave} variant="contained" disabled={saving}>
//           {saving ? <CircularProgress size={20} sx={{ mr: 1 }} /> : null}
//           Save Changes
//         </Button>
//       </DialogActions>
//     </Dialog>
//   );
// };

// // ─────────────────────────────────────────────────────────────────
// // QUIZ Edit Dialog — edit description + questions text only
// //                   (options/answers NOT editable)
// // ─────────────────────────────────────────────────────────────────
// const QuizEditDialog = ({ open, onClose, assessment, onSaved }) => {
//   const [description, setDescription] = useState('');
//   const [questions, setQuestions]     = useState([]);
//   const [loading, setLoading]         = useState(false);
//   const [saving, setSaving]           = useState(false);

//   useEffect(() => {
//     if (open && assessment) {
//       setDescription(assessment.description || '');
//       fetchQuestions();
//     }
//   }, [open, assessment]);

//   const fetchQuestions = async () => {
//     setLoading(true);
//     try {
//       const res = await axios.get(`assessment_questions/${assessment.id}`);
//       setQuestions(res.data);
//     } catch {
//       toast.error("Failed to load questions");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleQuestionTextChange = (qIdx, value) => {
//     setQuestions(prev => {
//       const updated = [...prev];
//       updated[qIdx] = { ...updated[qIdx], questionText: value };
//       return updated;
//     });
//   };

//   const handleSave = async () => {
//     if (!description.trim()) {
//       toast.error("Description is required");
//       return;
//     }
//     setSaving(true);
//     try {
//       // 1. Update assessment header
//       await axios.put(`trent_assessments/${assessment.id}`, {
//         batchId:        assessment.batchId,
//         moduleName:     assessment.moduleName,
//         description,
//         url:            assessment.url,
//         assessmentType: 'QUIZ',
//       });

//       // 2. Update each question text (only text, not options)
//       for (const q of questions) {
//         await axios.put(`assessment_questions/${q.id}`, {
//           trentAssessmentId: assessment.id,
//           questionText:      q.questionText,
//           questionType:      q.questionType,
//           marks:             q.marks,
//           orderIndex:        q.orderIndex,
//           options:           q.options || [],
//           matchPairs:        q.matchPairs || [],
//         });
//       }

//       toast.success("Quiz updated successfully");
//       onSaved();
//       onClose();
//     } catch {
//       toast.error("Failed to update quiz");
//     } finally {
//       setSaving(false);
//     }
//   };

//   const typeColors = {
//     MCQ: '#1976d2', TRUE_FALSE: '#388e3c',
//     MATCH: '#7b1fa2', SHORT_ANSWER: '#f57c00'
//   };

//   return (
//     <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth
//       PaperProps={{ sx: { maxHeight: '90vh' } }}>
//       <DialogTitle>
//         <Typography variant="h6" fontWeight="bold">Edit Quiz Assessment</Typography>
//         <Typography variant="body2" color="textSecondary">
//           Module: <strong>{assessment?.moduleName}</strong> (cannot be changed)
//         </Typography>
//       </DialogTitle>

//       <DialogContent sx={{ pt: 2 }}>
//         <Alert severity="info" sx={{ mb: 2 }}>
//           You can edit the <strong>description</strong> and <strong>question text</strong>.
//           Options and correct answers <strong>cannot</strong> be changed to preserve result integrity.
//         </Alert>

//         <TextField
//           label="Description" fullWidth multiline rows={2}
//           value={description} sx={{ mb: 3 }}
//           onChange={e => setDescription(e.target.value)}
//         />

//         {loading ? (
//           <Box display="flex" justifyContent="center" py={4}>
//             <CircularProgress />
//           </Box>
//         ) : (
//           questions.map((q, qIdx) => (
//             <Box key={q.id} sx={{
//               border: `2px solid ${typeColors[q.questionType] || '#ccc'}`,
//               borderRadius: 2, p: 2, mb: 2, backgroundColor: '#fafafa'
//             }}>
//               <Box display="flex" gap={1} alignItems="center" mb={1}>
//                 <Chip label={`Q${qIdx + 1}`} size="small" />
//                 <Chip label={q.questionType} size="small"
//                   sx={{ backgroundColor: typeColors[q.questionType], color: 'white' }} />
//                 <Chip label={`${q.marks} mark${q.marks > 1 ? 's' : ''}`}
//                   size="small" color="info" variant="outlined" />
//                 <Typography variant="caption" color="textSecondary" sx={{ ml: 'auto' }}>
//                   Question text only — options locked
//                 </Typography>
//               </Box>

//               <TextField
//                 label={`Question ${qIdx + 1} Text`}
//                 fullWidth multiline rows={2} size="small"
//                 value={q.questionText}
//                 onChange={e => handleQuestionTextChange(qIdx, e.target.value)}
//                 sx={{ mb: 1 }}
//               />

//               {/* Read-only options preview */}
//               {(q.questionType === 'MCQ' || q.questionType === 'TRUE_FALSE') && q.options?.length > 0 && (
//                 <Box sx={{ backgroundColor: '#f5f5f5', borderRadius: 1, p: 1 }}>
//                   <Typography variant="caption" color="textSecondary" fontWeight="bold">
//                     OPTIONS (read-only):
//                   </Typography>
//                   {q.options.map((opt, i) => (
//                     <Box key={i} display="flex" alignItems="center" gap={1} mt={0.5}>
//                       <Box sx={{
//                         width: 8, height: 8, borderRadius: '50%',
//                         backgroundColor: opt.isCorrect ? '#4caf50' : '#bbb'
//                       }} />
//                       <Typography variant="caption" sx={{
//                         color: opt.isCorrect ? 'success.main' : 'inherit',
//                         fontWeight: opt.isCorrect ? 'bold' : 'normal'
//                       }}>
//                         {opt.optionText} {opt.isCorrect ? '✓' : ''}
//                       </Typography>
//                     </Box>
//                   ))}
//                 </Box>
//               )}

//               {q.questionType === 'MATCH' && q.matchPairs?.length > 0 && (
//                 <Box sx={{ backgroundColor: '#f5f5f5', borderRadius: 1, p: 1 }}>
//                   <Typography variant="caption" color="textSecondary" fontWeight="bold">
//                     MATCH PAIRS (read-only):
//                   </Typography>
//                   {q.matchPairs.map((pair, i) => (
//                     <Typography key={i} variant="caption" display="block" mt={0.5}>
//                       {pair.leftItem} → {pair.rightItem}
//                     </Typography>
//                   ))}
//                 </Box>
//               )}

//               {q.questionType === 'SHORT_ANSWER' && (
//                 <Box sx={{ backgroundColor: '#fff3e0', borderRadius: 1, p: 1 }}>
//                   <Typography variant="caption" color={typeColors.SHORT_ANSWER}>
//                     📝 Free-text. Manually graded.
//                   </Typography>
//                 </Box>
//               )}
//             </Box>
//           ))
//         )}
//       </DialogContent>

//       <DialogActions sx={{ p: 2 }}>
//         <Button onClick={onClose} variant="outlined" color="error">Cancel</Button>
//         <Button onClick={handleSave} variant="contained" disabled={saving}>
//           {saving ? <CircularProgress size={20} sx={{ mr: 1 }} /> : null}
//           Save Changes
//         </Button>
//       </DialogActions>
//     </Dialog>
//   );
// };

// // ─────────────────────────────────────────────────────────────────
// // Main Admin Assessment Page
// // ─────────────────────────────────────────────────────────────────
// const App = () => {
//   const { id: encodedBatchId } = useParams();
//   const id = decryptData(encodedBatchId);

//   const [rows, setRows]         = useState([]);
//   const [open, setOpen]         = useState(false);
//   const [page, setPage]         = useState(0);
//   const [rowsPerPage, setRowsPerPage] = useState(5);
//   const [batchData, setBatchData]    = useState(null);
//   const [fileUploaded, setFileUploaded] = useState(false);

//   // Step tracking for QUIZ: 'form' | 'questions'
//   const [step, setStep]                   = useState('form');
//   const [savedAssessmentId, setSavedAssessmentId] = useState(null);

//   const [formData, setFormData] = useState({
//     description: '', moduleName: '', url: '', assessmentType: 'FILE',
//   });

//   const [questions, setQuestions] = useState([]);

//   // Edit dialogs
//   const [fileEditOpen, setFileEditOpen]   = useState(false);
//   const [quizEditOpen, setQuizEditOpen]   = useState(false);
//   const [viewQuizOpen, setViewQuizOpen]   = useState(false);
//   const [selectedAssessment, setSelectedAssessment] = useState(null);

//   // Delete confirmation
//   const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
//   const [deleteTarget, setDeleteTarget]         = useState(null);
//   const [deleteError, setDeleteError]           = useState('');
//   const [deleteChecking, setDeleteChecking]     = useState(false);

//   const CLOUDINARY_URL    = baseURL;
//   const CLOUDINARY_UPLOAD = CLOUDINARY_UPLOAD_PRESET;

//   useEffect(() => {
//     fetchBatchData();
//     fetchAssessmentData();
//   }, []);

//   const resetModal = () => {
//     setFormData({ description: '', moduleName: '', url: '', assessmentType: 'FILE' });
//     setQuestions([]);
//     setSavedAssessmentId(null);
//     setStep('form');
//     setFileUploaded(false);
//   };

//   const handleOpen  = () => { resetModal(); setOpen(true); };
//   const handleClose = () => { setOpen(false); resetModal(); };

//   const fetchBatchData = async () => {
//     try {
//       const res = await axios.get(`batch/${id}`);
//       setBatchData(res.data);
//     } catch (err) { console.error(err); }
//   };

//   const fetchAssessmentData = async () => {
//     try {
//       const res = await axios.get(`trent_assessments/${id}`);
//       setRows(res.data);
//     } catch (err) { console.error(err); }
//   };

//   // ── Delete with submission check ─────────────────────────────
//   const handleDeleteClick = async (row) => {
//     setDeleteTarget(row);
//     setDeleteError('');
//     setDeleteChecking(true);
//     setDeleteDialogOpen(true);

//     try {
//       // Check if any submissions exist for this assessment
//       const res = await axios.get(
//         row.assessmentType === 'QUIZ'
//           ? `quiz/submissions/count/${row.id}`
//           : `submissions/${row.id}`
//       );

//       const count = row.assessmentType === 'QUIZ'
//         ? (res.data?.count ?? res.data?.length ?? res.data ?? 0)
//         : (Array.isArray(res.data) ? res.data.length : 0);

//       if (count > 0) {
//         setDeleteError(
//           `Cannot delete: ${count} student submission${count > 1 ? 's' : ''} reference this assessment. Remove all submissions first.`
//         );
//       }
//     } catch (err) {
//       // If endpoint doesn't exist yet, allow delete (safe fallback)
//       console.warn("Could not check submissions:", err);
//     } finally {
//       setDeleteChecking(false);
//     }
//   };

//   const confirmDelete = async () => {
//     if (deleteError) return;
//     try {
//       await axios.delete(`trent_assessments/${deleteTarget.id}`);
//       setRows(prev => prev.filter(r => r.id !== deleteTarget.id));
//       toast.success("Deleted successfully");
//     } catch {
//       toast.error("Delete failed");
//     } finally {
//       setDeleteDialogOpen(false);
//       setDeleteTarget(null);
//     }
//   };

//   // ── Edit routing ─────────────────────────────────────────────
//   const handleEditClick = (row) => {
//     setSelectedAssessment({ ...row, batchId: id });
//     if (row.assessmentType === 'QUIZ') {
//       setQuizEditOpen(true);
//     } else {
//       setFileEditOpen(true);
//     }
//   };

//   // ── View Quiz ────────────────────────────────────────────────
//   const handleViewQuiz = (row) => {
//     setSelectedAssessment(row);
//     setViewQuizOpen(true);
//   };

//   const handleFileChange = async (e) => {
//     const file = e.target.files[0];
//     if (!file) return;
//     const fd = new FormData();
//     fd.append('file', file);
//     fd.append('upload_preset', CLOUDINARY_UPLOAD);
//     fd.append('public_id', `LMS/Trent/${file.name} - ${timestamp}`);
//     try {
//       const res  = await fetch(CLOUDINARY_URL, { method: 'POST', body: fd });
//       const data = await res.json();
//       if (data.secure_url) {
//         setFormData(prev => ({ ...prev, url: data.secure_url }));
//         setFileUploaded(true);
//         toast.success("File uploaded");
//       }
//     } catch {
//       toast.error("File upload failed");
//     }
//   };

//   // ── Step 1: Save new assessment ──────────────────────────────
//   const handleSaveAssessment = async () => {
//     if (!formData.moduleName || !formData.description) {
//       toast.error("Please fill Module and Description");
//       return;
//     }
//     const payload = {
//       batchId: id,
//       description: formData.description,
//       moduleName: formData.moduleName,
//       url: formData.assessmentType === 'FILE' ? formData.url : '',
//       assessmentType: formData.assessmentType,
//     };
//     try {
//       const response = await axios.post('trent_assessments/upload', payload);
//       if (formData.assessmentType === 'QUIZ') {
//         const newId = response.data?.id;
//         if (!newId) { toast.error("Failed to get assessment ID."); return; }
//         setSavedAssessmentId(newId);
//         setStep('questions');
//         toast.success("Assessment saved! Now add questions.");
//         fetchAssessmentData();
//       } else {
//         toast.success("Assessment created");
//         fetchAssessmentData();
//         handleClose();
//       }
//     } catch {
//       toast.error("Failed to save assessment");
//     }
//   };

//   // ── Step 2: Save all questions (new quiz) ────────────────────
//   const handleSaveAllQuestions = async () => {
//     if (questions.length === 0) { toast.error("Add at least one question"); return; }
//     for (let i = 0; i < questions.length; i++) {
//       const q = questions[i];
//       if (!q.questionText.trim()) { toast.error(`Question ${i + 1} text is empty`); return; }
//       if (q.questionType === 'MCQ' && q.options.filter(o => o.optionText.trim()).length < 2) {
//         toast.error(`Question ${i + 1} needs at least 2 options`); return;
//       }
//       if (q.questionType === 'MCQ' && !q.options.some(o => o.isCorrect)) {
//         toast.error(`Question ${i + 1}: select a correct answer`); return;
//       }
//       if (q.questionType === 'MATCH' && q.matchPairs.length < 1) {
//         toast.error(`Question ${i + 1} needs at least 1 match pair`); return;
//       }
//     }
//     try {
//       for (const q of questions) {
//         await axios.post('assessment_questions/add', {
//           trentAssessmentId: savedAssessmentId,
//           questionText: q.questionText,
//           questionType: q.questionType,
//           marks: q.marks,
//           orderIndex: q.orderIndex,
//           options: (q.questionType === 'MCQ' || q.questionType === 'TRUE_FALSE') ? q.options : [],
//           matchPairs: q.questionType === 'MATCH' ? q.matchPairs : [],
//         });
//       }
//       toast.success(`${questions.length} question(s) saved!`);
//       handleClose();
//     } catch {
//       toast.error("Failed to save questions");
//     }
//   };

//   // ── Question helpers ─────────────────────────────────────────
//   const addQuestion = () => {
//     setQuestions(prev => [...prev, {
//       questionText: '', questionType: 'MCQ', marks: 1, orderIndex: prev.length + 1,
//       options: [
//         { optionText: '', isCorrect: false }, { optionText: '', isCorrect: false },
//         { optionText: '', isCorrect: false }, { optionText: '', isCorrect: false },
//       ],
//       matchPairs: [],
//     }]);
//   };

//   const removeQuestion = (qIdx) => setQuestions(prev => prev.filter((_, i) => i !== qIdx));

//   const updateQuestion = (qIdx, field, value) => {
//     setQuestions(prev => {
//       const updated = [...prev];
//       updated[qIdx] = { ...updated[qIdx], [field]: value };
//       if (field === 'questionType') {
//         if (value === 'TRUE_FALSE') {
//           updated[qIdx].options = [
//             { optionText: 'True', isCorrect: true },
//             { optionText: 'False', isCorrect: false },
//           ];
//           updated[qIdx].matchPairs = [];
//         } else if (value === 'MCQ') {
//           updated[qIdx].options = [
//             { optionText: '', isCorrect: false }, { optionText: '', isCorrect: false },
//             { optionText: '', isCorrect: false }, { optionText: '', isCorrect: false },
//           ];
//           updated[qIdx].matchPairs = [];
//         } else if (value === 'MATCH') {
//           updated[qIdx].options = [];
//           updated[qIdx].matchPairs = [{ leftItem: '', rightItem: '' }, { leftItem: '', rightItem: '' }];
//         } else if (value === 'SHORT_ANSWER') {
//           updated[qIdx].options = [];
//           updated[qIdx].matchPairs = [];
//         }
//       }
//       return updated;
//     });
//   };

//   const updateOption = (qIdx, oIdx, field, value) => {
//     setQuestions(prev => {
//       const updated = [...prev];
//       const opts = [...updated[qIdx].options];
//       if (field === 'isCorrect') {
//         opts.forEach((o, i) => { opts[i] = { ...o, isCorrect: i === oIdx }; });
//       } else {
//         opts[oIdx] = { ...opts[oIdx], [field]: value };
//       }
//       updated[qIdx].options = opts;
//       return updated;
//     });
//   };

//   const addOption    = (qIdx) => setQuestions(prev => {
//     const updated = [...prev];
//     updated[qIdx].options.push({ optionText: '', isCorrect: false });
//     return updated;
//   });

//   const removeOption = (qIdx, oIdx) => setQuestions(prev => {
//     const updated = [...prev];
//     updated[qIdx].options = updated[qIdx].options.filter((_, i) => i !== oIdx);
//     return updated;
//   });

//   const updateMatchPair = (qIdx, pIdx, field, value) => {
//     setQuestions(prev => {
//       const updated = [...prev];
//       const pairs = [...updated[qIdx].matchPairs];
//       pairs[pIdx] = { ...pairs[pIdx], [field]: value };
//       updated[qIdx].matchPairs = pairs;
//       return updated;
//     });
//   };

//   const addMatchPair    = (qIdx) => setQuestions(prev => {
//     const updated = [...prev];
//     updated[qIdx].matchPairs.push({ leftItem: '', rightItem: '' });
//     return updated;
//   });

//   const removeMatchPair = (qIdx, pIdx) => setQuestions(prev => {
//     const updated = [...prev];
//     updated[qIdx].matchPairs = updated[qIdx].matchPairs.filter((_, i) => i !== pIdx);
//     return updated;
//   });

//   const isSaveDisabled = () => {
//     if (!formData.description || !formData.moduleName) return true;
//     if (formData.assessmentType === 'FILE' && !fileUploaded) return true;
//     return false;
//   };

//   const typeColors = {
//     MCQ: '#1976d2', TRUE_FALSE: '#388e3c',
//     MATCH: '#7b1fa2', SHORT_ANSWER: '#f57c00'
//   };

//   return (
//     <div>
//       <Header />
//       <br />
//       <Box p={4}>
//         <TableContainer component={Paper}>
//           <Box display="flex" gap={2} mb={2} p={1}>
//             <Link to="/Allcourse">
//               <Button variant="contained" sx={{ backgroundColor: '#007bff' }}>All Courses</Button>
//             </Link>
//             <Button variant="contained" sx={{ backgroundColor: '#007bff' }} onClick={handleOpen}>
//               Add New Template
//             </Button>
//           </Box>

//           <Table>
//             <TableHead>
//               <TableRow>
//                 <TableCell sx={{ fontWeight: 'bold' }}>Description</TableCell>
//                 <TableCell sx={{ fontWeight: 'bold' }}>Type</TableCell>
//                 <TableCell sx={{ fontWeight: 'bold' }}>Created At</TableCell>
//                 <TableCell sx={{ fontWeight: 'bold' }}>Module</TableCell>
//                 <TableCell sx={{ fontWeight: 'bold' }}>Actions</TableCell>
//               </TableRow>
//             </TableHead>
//             <TableBody>
//               {rows.length > 0 ? (
//                 rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row, index) => (
//                   <TableRow key={index}>
//                     <TableCell>{row.description}</TableCell>
//                     <TableCell>
//                       <Chip label={row.assessmentType || 'FILE'}
//                         color={row.assessmentType === 'QUIZ' ? 'secondary' : 'primary'} size="small" />
//                     </TableCell>
//                     <TableCell>
//                       {row.createdAt ? format(new Date(row.createdAt), 'dd/MM/yyyy HH:mm') : 'N/A'}
//                     </TableCell>
//                     <TableCell>{row.moduleName}</TableCell>
//                     <TableCell>
//                       <Box display="flex" gap={0.5} flexWrap="wrap">
//                         {/* View — only for QUIZ */}
//                         {row.assessmentType === 'QUIZ' && (
//                           <Button variant="outlined" color="info" size="small"
//                             startIcon={<VisibilityIcon />}
//                             onClick={() => handleViewQuiz(row)}>
//                             View
//                           </Button>
//                         )}
//                         {/* View File — only for FILE */}
//                         {row.assessmentType !== 'QUIZ' && (
//                           <Button variant="outlined" color="primary" size="small"
//                             onClick={() => window.open(row.url, "_blank")}>
//                             View File
//                           </Button>
//                         )}
//                         {/* Edit */}
//                         <Button variant="outlined" color="success" size="small"
//                           startIcon={<EditIcon />}
//                           onClick={() => handleEditClick(row)}>
//                           Edit
//                         </Button>
//                         {/* Delete */}
//                         <Button variant="outlined" color="error" size="small"
//                           startIcon={<DeleteIcon />}
//                           onClick={() => handleDeleteClick(row)}>
//                           Delete
//                         </Button>
//                       </Box>
//                     </TableCell>
//                   </TableRow>
//                 ))
//               ) : (
//                 <TableRow>
//                   <TableCell colSpan={5} align="center">No data available</TableCell>
//                 </TableRow>
//               )}
//             </TableBody>
//           </Table>

//           <TablePagination rowsPerPageOptions={[5, 10, 15]} component="div"
//             count={rows.length} rowsPerPage={rowsPerPage} page={page}
//             onPageChange={(e, n) => setPage(n)}
//             onRowsPerPageChange={e => { setRowsPerPage(parseInt(e.target.value, 10)); setPage(0); }} />
//         </TableContainer>

//         {/* ── CREATE Modal ─────────────────────────────────────── */}
//         <Modal open={open} onClose={handleClose}>
//           <Box component={Paper} sx={{
//             width: '90%', maxWidth: 750,
//             maxHeight: '90vh', overflowY: 'auto',
//             margin: 'auto', mt: '3%', p: 4, borderRadius: 2,
//           }}>
//             {step === 'form' && (
//               <>
//                 <Typography variant="h6" textAlign="center" color="primary" mb={2}>
//                   Add New Assessment
//                 </Typography>

//                 <Box mb={2}>
//                   <FormLabel sx={{ fontWeight: 'bold' }}>Assessment Type</FormLabel>
//                   <RadioGroup row value={formData.assessmentType}
//                     onChange={e => setFormData({ ...formData, assessmentType: e.target.value })}>
//                     <FormControlLabel value="FILE" control={<Radio />} label="File Upload" />
//                     <FormControlLabel value="QUIZ" control={<Radio />} label="Quiz (MCQ / T-F / Match / Short Answer)" />
//                   </RadioGroup>
//                 </Box>

//                 <TextField select label="Module" fullWidth variant="outlined" sx={{ mb: 2 }}
//                   value={formData.moduleName}
//                   onChange={e => setFormData({ ...formData, moduleName: e.target.value })}>
//                   {batchData?.moduleDetails?.length > 0
//                     ? batchData.moduleDetails.map(m => (
//                       <MenuItem key={m.id} value={m.moduleName}>{m.moduleName}</MenuItem>
//                     ))
//                     : <MenuItem disabled>No modules available</MenuItem>}
//                 </TextField>

//                 <TextField label="Description" fullWidth multiline rows={3}
//                   variant="outlined" sx={{ mb: 2 }}
//                   value={formData.description}
//                   onChange={e => setFormData({ ...formData, description: e.target.value })} />

//                 {formData.assessmentType === 'FILE' && (
//                   <TextField type="file" fullWidth variant="outlined"
//                     InputLabelProps={{ shrink: true }}
//                     label="Upload File" sx={{ mb: 2 }}
//                     onChange={e => {
//                       const file = e.target.files[0];
//                       if (file && file.size > 8 * 1024 * 1024) {
//                         e.target.value = ""; alert("File size must be less than 8MB.");
//                       } else { handleFileChange(e); }
//                     }} />
//                 )}

//                 <Box display="flex" gap={2}>
//                   <Button variant="contained" color="primary"
//                     disabled={isSaveDisabled()} onClick={handleSaveAssessment}>
//                     {formData.assessmentType === 'QUIZ'
//                       ? 'Save & Add Questions →' : 'Save'}
//                   </Button>
//                   <Button variant="outlined" color="error" onClick={handleClose}>Cancel</Button>
//                 </Box>
//               </>
//             )}

//             {step === 'questions' && (
//               <>
//                 <Box display="flex" justifyContent="space-between" alignItems="center" mb={1}>
//                   <Box>
//                     <Typography variant="h6" color="primary" fontWeight="bold">Add Questions</Typography>
//                     <Typography variant="body2" color="textSecondary">
//                       Assessment ID: {savedAssessmentId} · {questions.length} question(s)
//                     </Typography>
//                   </Box>
//                   <Button variant="contained" color="primary" startIcon={<AddIcon />} onClick={addQuestion}>
//                     Add Question
//                   </Button>
//                 </Box>

//                 <Divider sx={{ mb: 2 }} />

//                 {questions.length === 0 && (
//                   <Box textAlign="center" py={4} sx={{ border: '2px dashed #ccc', borderRadius: 2 }}>
//                     <Typography color="textSecondary" mb={1}>No questions yet</Typography>
//                     <Button variant="outlined" startIcon={<AddIcon />} onClick={addQuestion}>
//                       Add First Question
//                     </Button>
//                   </Box>
//                 )}

//                 {questions.map((q, qIdx) => (
//                   <Box key={qIdx} sx={{
//                     border: `2px solid ${typeColors[q.questionType] || '#ccc'}`,
//                     borderRadius: 2, p: 2, mb: 2, backgroundColor: '#fafafa'
//                   }}>
//                     <Box display="flex" justifyContent="space-between" alignItems="center" mb={1}>
//                       <Typography fontWeight="bold" color={typeColors[q.questionType]}>
//                         Question {qIdx + 1}
//                       </Typography>
//                       <IconButton color="error" size="small" onClick={() => removeQuestion(qIdx)}>
//                         <DeleteIcon />
//                       </IconButton>
//                     </Box>

//                     <Box display="flex" gap={2} mb={1}>
//                       <TextField select label="Question Type" size="small"
//                         value={q.questionType} sx={{ flex: 2 }}
//                         onChange={e => updateQuestion(qIdx, 'questionType', e.target.value)}>
//                         {Object.entries(typeColors).map(([type, color]) => (
//                           <MenuItem key={type} value={type}>
//                             <Box display="flex" alignItems="center" gap={1}>
//                               <Chip label={type} size="small" sx={{ backgroundColor: color, color: 'white' }} />
//                               {type === 'MCQ' ? 'Multiple Choice' : type === 'TRUE_FALSE' ? 'True / False'
//                                 : type === 'MATCH' ? 'Match the Following' : 'Short Answer'}
//                             </Box>
//                           </MenuItem>
//                         ))}
//                       </TextField>
//                       <TextField label="Marks" type="number" size="small"
//                         value={q.marks} sx={{ width: 90 }} inputProps={{ min: 1 }}
//                         onChange={e => updateQuestion(qIdx, 'marks', parseInt(e.target.value) || 1)} />
//                     </Box>

//                     <TextField label={`Question ${qIdx + 1} Text`} fullWidth multiline rows={2}
//                       size="small" value={q.questionText} sx={{ mb: 1 }}
//                       onChange={e => updateQuestion(qIdx, 'questionText', e.target.value)} />

//                     {/* MCQ */}
//                     {q.questionType === 'MCQ' && (
//                       <Box sx={{ backgroundColor: '#e3f2fd', borderRadius: 1, p: 1.5 }}>
//                         <Typography variant="body2" fontWeight="bold" color={typeColors.MCQ} mb={1}>
//                           Options — select the correct answer (●)
//                         </Typography>
//                         {q.options.map((opt, oIdx) => (
//                           <Box key={oIdx} display="flex" alignItems="center" gap={1} mb={0.5}>
//                             <Radio size="small" checked={opt.isCorrect}
//                               onChange={() => updateOption(qIdx, oIdx, 'isCorrect', true)}
//                               sx={{ color: typeColors.MCQ }} />
//                             <TextField size="small" fullWidth placeholder={`Option ${oIdx + 1}`}
//                               value={opt.optionText}
//                               onChange={e => updateOption(qIdx, oIdx, 'optionText', e.target.value)} />
//                             {q.options.length > 2 && (
//                               <IconButton size="small" color="error" onClick={() => removeOption(qIdx, oIdx)}>
//                                 <DeleteIcon fontSize="small" />
//                               </IconButton>
//                             )}
//                           </Box>
//                         ))}
//                         <Button size="small" startIcon={<AddIcon />} onClick={() => addOption(qIdx)} sx={{ mt: 0.5 }}>
//                           Add Option
//                         </Button>
//                       </Box>
//                     )}

//                     {/* TRUE/FALSE */}
//                     {q.questionType === 'TRUE_FALSE' && (
//                       <Box sx={{ backgroundColor: '#e8f5e9', borderRadius: 1, p: 1.5 }}>
//                         <Typography variant="body2" fontWeight="bold" color={typeColors.TRUE_FALSE} mb={1}>
//                           Select the correct answer
//                         </Typography>
//                         <RadioGroup row value={q.options.find(o => o.isCorrect)?.optionText || 'True'}
//                           onChange={e => setQuestions(prev => {
//                             const updated = [...prev];
//                             updated[qIdx].options = [
//                               { optionText: 'True', isCorrect: e.target.value === 'True' },
//                               { optionText: 'False', isCorrect: e.target.value === 'False' },
//                             ];
//                             return updated;
//                           })}>
//                           <FormControlLabel value="True" control={<Radio sx={{ color: typeColors.TRUE_FALSE }} />}
//                             label={<Typography fontWeight="bold">✓ True</Typography>} />
//                           <FormControlLabel value="False" control={<Radio sx={{ color: typeColors.TRUE_FALSE }} />}
//                             label={<Typography fontWeight="bold">✗ False</Typography>} />
//                         </RadioGroup>
//                       </Box>
//                     )}

//                     {/* MATCH */}
//                     {q.questionType === 'MATCH' && (
//                       <Box sx={{ backgroundColor: '#f3e5f5', borderRadius: 1, p: 1.5 }}>
//                         <Typography variant="body2" fontWeight="bold" color={typeColors.MATCH} mb={1}>
//                           Match Pairs — Left column → Right column
//                         </Typography>
//                         {q.matchPairs.map((pair, pIdx) => (
//                           <Box key={pIdx} display="flex" alignItems="center" gap={1} mb={0.5}>
//                             <TextField size="small" placeholder="Left item" value={pair.leftItem} sx={{ flex: 1 }}
//                               onChange={e => updateMatchPair(qIdx, pIdx, 'leftItem', e.target.value)} />
//                             <Typography color={typeColors.MATCH} fontWeight="bold">→</Typography>
//                             <TextField size="small" placeholder="Right item" value={pair.rightItem} sx={{ flex: 1 }}
//                               onChange={e => updateMatchPair(qIdx, pIdx, 'rightItem', e.target.value)} />
//                             {q.matchPairs.length > 1 && (
//                               <IconButton size="small" color="error" onClick={() => removeMatchPair(qIdx, pIdx)}>
//                                 <DeleteIcon fontSize="small" />
//                               </IconButton>
//                             )}
//                           </Box>
//                         ))}
//                         <Button size="small" startIcon={<AddIcon />} onClick={() => addMatchPair(qIdx)} sx={{ mt: 0.5 }}>
//                           Add Pair
//                         </Button>
//                       </Box>
//                     )}

//                     {/* SHORT ANSWER — shows expected answer field for reference */}
//                     {q.questionType === 'SHORT_ANSWER' && (
//                       <Box sx={{ backgroundColor: '#fff3e0', borderRadius: 1, p: 1.5 }}>
//                         <Typography variant="body2" color={typeColors.SHORT_ANSWER} mb={1}>
//                           📝 Student types a free-text answer. Graded manually by the teacher.
//                         </Typography>
//                         <TextField
//                           label="Model Answer / Marking Guide (optional — for teacher reference only)"
//                           fullWidth multiline rows={2} size="small"
//                           placeholder="Enter expected answer or marking criteria..."
//                           helperText="This is only visible to the teacher when grading, not shown to students."
//                         />
//                       </Box>
//                     )}
//                   </Box>
//                 ))}

//                 <Box display="flex" gap={2} mt={2}>
//                   <Button variant="contained" color="success"
//                     disabled={questions.length === 0} onClick={handleSaveAllQuestions}>
//                     Save All Questions ({questions.length}) ✓
//                   </Button>
//                   <Button variant="outlined" color="error" onClick={handleClose}>Cancel</Button>
//                 </Box>
//               </>
//             )}
//           </Box>
//         </Modal>
//       </Box>

//       {/* ── Delete Confirmation Dialog ───────────────────────── */}
//       <Dialog open={deleteDialogOpen} onClose={() => setDeleteDialogOpen(false)} maxWidth="sm" fullWidth>
//         <DialogTitle>Confirm Delete</DialogTitle>
//         <DialogContent>
//           {deleteChecking ? (
//             <Box display="flex" alignItems="center" gap={2}>
//               <CircularProgress size={20} />
//               <Typography>Checking for student submissions...</Typography>
//             </Box>
//           ) : deleteError ? (
//             <Alert severity="error">{deleteError}</Alert>
//           ) : (
//             <Typography>
//               Are you sure you want to delete <strong>"{deleteTarget?.description}"</strong>?
//               This action cannot be undone.
//             </Typography>
//           )}
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={() => setDeleteDialogOpen(false)} variant="outlined">Cancel</Button>
//           <Button onClick={confirmDelete} variant="contained" color="error"
//             disabled={!!deleteError || deleteChecking}>
//             Delete
//           </Button>
//         </DialogActions>
//       </Dialog>

//       {/* ── FILE Edit Dialog ─────────────────────────────────── */}
//       <FileEditDialog
//         open={fileEditOpen}
//         onClose={() => setFileEditOpen(false)}
//         assessment={selectedAssessment}
//         batchData={batchData}
//         onSaved={fetchAssessmentData}
//       />

//       {/* ── QUIZ Edit Dialog ─────────────────────────────────── */}
//       <QuizEditDialog
//         open={quizEditOpen}
//         onClose={() => setQuizEditOpen(false)}
//         assessment={selectedAssessment}
//         onSaved={fetchAssessmentData}
//       />

//       {/* ── MCQ View Dialog ──────────────────────────────────── */}
//       <MCQViewDialog
//         open={viewQuizOpen}
//         onClose={() => setViewQuizOpen(false)}
//         assessment={selectedAssessment}
//       />

//       <ToastContainer position="bottom-right" autoClose={3000} hideProgressBar />
//     </div>
//   );
// };

// export default App;



import React, { useState, useEffect } from 'react';
import { Link, useParams } from "react-router-dom";
import axios from "../../Axiosinstance";
import {
  Box, Button, Table, TableBody, TableCell, TableContainer,
  TableHead, TableRow, Paper, TablePagination, Modal, TextField,
  MenuItem, Typography, Chip, IconButton, Divider,
  Radio, RadioGroup, FormControlLabel, FormLabel, Dialog,
  DialogTitle, DialogContent, DialogActions, CircularProgress,
  Alert, Stepper, Step, StepLabel, Tooltip, Badge,
  InputAdornment, Stack, Avatar, LinearProgress
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import VisibilityIcon from '@mui/icons-material/Visibility';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import QuizIcon from '@mui/icons-material/Quiz';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import SchoolIcon from '@mui/icons-material/School';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import DragIndicatorIcon from '@mui/icons-material/DragIndicator';
import EmojiObjectsIcon from '@mui/icons-material/EmojiObjects';
import Header from '../../components/Header';
import { CLOUDINARY_UPLOAD_PRESET, baseURL, timestamp } from '../../common';
import { format } from 'date-fns';
import { toast, ToastContainer } from 'react-toastify';
import { decryptData } from '../../Axiosinstance';

// ─── Theme constants ─────────────────────────────────────────────
const COLORS = {
  primary:    '#1a56db',
  secondary:  '#6366f1',
  MCQ:        '#1a56db',
  TRUE_FALSE: '#059669',
  MATCH:      '#7c3aed',
  SHORT_ANSWER: '#d97706',
  success:    '#059669',
  error:      '#dc2626',
  bg:         '#f8fafc',
  card:       '#ffffff',
  border:     '#e2e8f0',
  textPrimary:'#0f172a',
  textMuted:  '#64748b',
};

const TYPE_META = {
  MCQ:          { label: 'Multiple Choice', color: COLORS.MCQ,          bg: '#eff6ff', icon: '🔘' },
  TRUE_FALSE:   { label: 'True / False',    color: COLORS.TRUE_FALSE,   bg: '#f0fdf4', icon: '✅' },
  MATCH:        { label: 'Match Pairs',     color: COLORS.MATCH,        bg: '#f5f3ff', icon: '🔗' },
  // SHORT_ANSWER: { label: 'Short Answer',    color: COLORS.SHORT_ANSWER, bg: '#fffbeb', icon: '✏️' },
};

const sxCard = {
  background: COLORS.card,
  border: `1px solid ${COLORS.border}`,
  borderRadius: 3,
  boxShadow: '0 1px 3px rgba(0,0,0,.06)',
};

const sxTableHead = {
  backgroundColor: '#f1f5f9',
  '& th': {
    fontWeight: 700,
    fontSize: '0.78rem',
    letterSpacing: '.06em',
    textTransform: 'uppercase',
    color: COLORS.textMuted,
    borderBottom: `2px solid ${COLORS.border}`,
    py: 1.5,
  }
};

// ─────────────────────────────────────────────────────────────────
// Reusable: Marks badge
// ─────────────────────────────────────────────────────────────────
const MarksBadge = ({ marks }) => (
  <Chip
    label={`${marks} mark${marks !== 1 ? 's' : ''}`}
    size="small"
    sx={{
      backgroundColor: '#fef9c3',
      color: '#854d0e',
      fontWeight: 700,
      fontSize: '0.7rem',
      border: '1px solid #fde68a',
      height: 22,
    }}
  />
);

// ─────────────────────────────────────────────────────────────────
// MCQ View Dialog
// ─────────────────────────────────────────────────────────────────
const MCQViewDialog = ({ open, onClose, assessment }) => {
  const [questions, setQuestions] = useState([]);
  const [loading, setLoading]     = useState(false);

  useEffect(() => {
    if (open && assessment?.id) fetchQuestions();
  }, [open, assessment]);

  const fetchQuestions = async () => {
    setLoading(true);
    try {
      const res = await axios.get(`assessment_questions/${assessment.id}`);
      setQuestions(res.data);
    } catch {
      toast.error("Failed to load questions");
    } finally {
      setLoading(false);
    }
  };

  const totalMarks = questions.reduce((s, q) => s + (Number(q.marks) || 0), 0);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth
      PaperProps={{ sx: { borderRadius: 3, maxHeight: '90vh' } }}>

      {/* Header */}
      <Box sx={{ background: 'linear-gradient(135deg,#1a56db 0%,#6366f1 100%)', px: 3, py: 2.5 }}>
        <Box display="flex" justifyContent="space-between" alignItems="flex-start">
          <Box>
            <Typography variant="h6" fontWeight={700} color="#fff">
              {assessment?.description}
            </Typography>
            <Typography variant="body2" sx={{ color: 'rgba(255,255,255,.75)', mt: .3 }}>
              Module: {assessment?.moduleName}
            </Typography>
          </Box>
          <Stack direction="row" spacing={1}>
            <Chip label={`${questions.length} questions`} size="small"
              sx={{ backgroundColor: 'rgba(255,255,255,.2)', color: '#fff', fontWeight: 600 }} />
            <Chip label={`${totalMarks} marks`} size="small"
              sx={{ backgroundColor: 'rgba(255,255,255,.2)', color: '#fff', fontWeight: 600 }} />
          </Stack>
        </Box>
      </Box>

      <DialogContent sx={{ p: 3, backgroundColor: COLORS.bg }}>
        {loading ? (
          <Box display="flex" flexDirection="column" alignItems="center" py={6} gap={2}>
            <CircularProgress size={36} />
            <Typography color="textSecondary" variant="body2">Loading questions...</Typography>
          </Box>
        ) : questions.length === 0 ? (
          <Box textAlign="center" py={6}>
            <QuizIcon sx={{ fontSize: 48, color: COLORS.border, mb: 1 }} />
            <Typography color="textSecondary">No questions added yet.</Typography>
          </Box>
        ) : (
          questions.map((q, index) => {
            const meta = TYPE_META[q.questionType] || TYPE_META.MCQ;
            return (
              <Box key={q.id} sx={{
                ...sxCard,
                border: `1.5px solid ${meta.color}22`,
                backgroundColor: meta.bg,
                p: 2.5, mb: 2,
              }}>
                {/* Question header */}
                <Box display="flex" justifyContent="space-between" alignItems="flex-start" mb={1.5}>
                  <Box sx={{ flex: 1 }}>
                    <Box display="flex" alignItems="center" gap={1} mb={.5}>
                      <Avatar sx={{ width: 26, height: 26, fontSize: '0.75rem', fontWeight: 700,
                        backgroundColor: meta.color, color: '#fff' }}>
                        {index + 1}
                      </Avatar>
                      <Typography fontWeight={700} fontSize="0.95rem" color={COLORS.textPrimary}>
                        {q.questionText}
                      </Typography>
                    </Box>
                    <Stack direction="row" spacing={1} mt={.5}>
                      <Chip label={meta.icon + ' ' + meta.label} size="small"
                        sx={{ backgroundColor: meta.color, color: '#fff', fontWeight: 600, fontSize: '0.7rem' }} />
                      <MarksBadge marks={q.marks || 0} />
                    </Stack>
                  </Box>
                </Box>

                <Divider sx={{ mb: 1.5, borderColor: `${meta.color}30` }} />

                {/* MCQ */}
                {q.questionType === 'MCQ' && (
                  <Box>
                    <Typography variant="caption" fontWeight={700} color={COLORS.textMuted}
                      sx={{ display: 'block', mb: 1, letterSpacing: '.05em' }}>
                      OPTIONS — ✓ marks correct answer
                    </Typography>
                    {q.options?.map((opt, i) => (
                      <Box key={i} display="flex" alignItems="center" gap={1.5} mb={.75} sx={{
                        backgroundColor: opt.isCorrect ? '#dcfce7' : '#fff',
                        border: `1.5px solid ${opt.isCorrect ? '#22c55e' : '#e2e8f0'}`,
                        borderRadius: 2, px: 1.5, py: 1,
                      }}>
                        <Box sx={{
                          width: 22, height: 22, borderRadius: '50%', flexShrink: 0,
                          backgroundColor: opt.isCorrect ? '#22c55e' : '#e2e8f0',
                          display: 'flex', alignItems: 'center', justifyContent: 'center',
                        }}>
                          {opt.isCorrect && <CheckCircleIcon sx={{ fontSize: 16, color: '#fff' }} />}
                        </Box>
                        <Typography variant="body2" fontWeight={opt.isCorrect ? 700 : 400}
                          color={opt.isCorrect ? '#15803d' : COLORS.textPrimary} sx={{ flex: 1 }}>
                          {opt.optionText}
                        </Typography>
                        {opt.isCorrect && (
                          <Chip label="Correct" size="small"
                            sx={{ backgroundColor: '#dcfce7', color: '#15803d', fontWeight: 700,
                              fontSize: '0.65rem', height: 20 }} />
                        )}
                      </Box>
                    ))}
                  </Box>
                )}

                {/* TRUE/FALSE */}
                {q.questionType === 'TRUE_FALSE' && (
                  <Box>
                    <Typography variant="caption" fontWeight={700} color={COLORS.textMuted}
                      sx={{ display: 'block', mb: 1, letterSpacing: '.05em' }}>
                      CORRECT ANSWER
                    </Typography>
                    <Stack direction="row" spacing={1.5}>
                      {q.options?.map((opt, i) => (
                        <Box key={i} sx={{
                          border: `2px solid ${opt.isCorrect ? '#22c55e' : '#e2e8f0'}`,
                          backgroundColor: opt.isCorrect ? '#dcfce7' : '#fff',
                          borderRadius: 2, px: 3, py: 1.25, minWidth: 90, textAlign: 'center',
                          fontWeight: opt.isCorrect ? 700 : 400,
                          color: opt.isCorrect ? '#15803d' : COLORS.textMuted,
                          fontSize: '0.9rem',
                        }}>
                          {opt.optionText} {opt.isCorrect ? '✓' : ''}
                        </Box>
                      ))}
                    </Stack>
                  </Box>
                )}

                {/* MATCH */}
                {q.questionType === 'MATCH' && (
                  <Box>
                    <Typography variant="caption" fontWeight={700} color={COLORS.textMuted}
                      sx={{ display: 'block', mb: 1, letterSpacing: '.05em' }}>
                      CORRECT PAIRS
                    </Typography>
                    {q.matchPairs?.map((pair, pi) => (
                      <Box key={pi} display="flex" alignItems="center" gap={1.5} mb={.75} sx={{
                        backgroundColor: '#ede9fe', borderRadius: 2, px: 1.5, py: 1,
                        border: '1px solid #c4b5fd',
                      }}>
                        <Typography variant="body2" fontWeight={700} color="#5b21b6" sx={{ flex: 1 }}>
                          {pair.leftItem}
                        </Typography>
                        <Chip label="→" size="small"
                          sx={{ backgroundColor: '#7c3aed', color: '#fff', fontWeight: 700, height: 20 }} />
                        <Typography variant="body2" fontWeight={600} color="#059669" sx={{ flex: 1 }}>
                          {pair.rightItem}
                        </Typography>
                      </Box>
                    ))}
                  </Box>
                )}

                {/* SHORT ANSWER */}
                {q.questionType === 'SHORT_ANSWER' && (
                  <Box sx={{ backgroundColor: '#fffbeb', borderRadius: 2, p: 1.5,
                    border: '1px solid #fde68a' }}>
                    <Typography variant="body2" color="#92400e" display="flex" alignItems="center" gap={.5}>
                      <EmojiObjectsIcon fontSize="small" /> Free-text response — graded manually by the teacher.
                    </Typography>
                  </Box>
                )}
              </Box>
            );
          })
        )}
      </DialogContent>

      <DialogActions sx={{ p: 2.5, borderTop: `1px solid ${COLORS.border}` }}>
        <Button onClick={onClose} variant="contained"
          sx={{ borderRadius: 2, textTransform: 'none', fontWeight: 600, px: 3 }}>
          Close Preview
        </Button>
      </DialogActions>
    </Dialog>
  );
};

// ─────────────────────────────────────────────────────────────────
// File Edit Dialog
// ─────────────────────────────────────────────────────────────────
const FileEditDialog = ({ open, onClose, assessment, onSaved }) => {
  const [description, setDescription] = useState('');
  const [newFileUrl, setNewFileUrl]    = useState('');
  const [fileUploaded, setFileUploaded] = useState(false);
  const [saving, setSaving]            = useState(false);
  const [uploading, setUploading]      = useState(false);

  useEffect(() => {
    if (assessment) {
      setDescription(assessment.description || '');
      setNewFileUrl('');
      setFileUploaded(false);
    }
  }, [assessment]);

  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setUploading(true);
    const fd = new FormData();
    fd.append('file', file);
    fd.append('upload_preset', CLOUDINARY_UPLOAD_PRESET);
    fd.append('public_id', `LMS/Trent/${file.name} - ${timestamp}`);
    try {
      const res  = await fetch(baseURL, { method: 'POST', body: fd });
      const data = await res.json();
      if (data.secure_url) {
        setNewFileUrl(data.secure_url);
        setFileUploaded(true);
        toast.success("New file ready");
      }
    } catch {
      toast.error("File upload failed");
    } finally {
      setUploading(false);
    }
  };

  const handleSave = async () => {
    if (!description.trim()) { toast.error("Description is required"); return; }
    setSaving(true);
    try {
      await axios.put(`trent_assessments/${assessment.id}`, {
        batchId: assessment.batchId,
        moduleName: assessment.moduleName,
        description,
        url: fileUploaded ? newFileUrl : assessment.url,
        assessmentType: 'FILE',
      });
      toast.success("Assessment updated");
      onSaved();
      onClose();
    } catch {
      toast.error("Failed to update");
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth
      PaperProps={{ sx: { borderRadius: 3 } }}>
      <Box sx={{ background: 'linear-gradient(135deg,#0ea5e9 0%,#1a56db 100%)', px: 3, py: 2.5 }}>
        <Box display="flex" alignItems="center" gap={1.5}>
          <Avatar sx={{ backgroundColor: 'rgba(255,255,255,.2)', width: 38, height: 38 }}>
            <UploadFileIcon sx={{ color: '#fff', fontSize: 20 }} />
          </Avatar>
          <Box>
            <Typography variant="h6" fontWeight={700} color="#fff">Edit File Assessment</Typography>
            <Typography variant="body2" sx={{ color: 'rgba(255,255,255,.75)' }}>
              Module: {assessment?.moduleName}
            </Typography>
          </Box>
        </Box>
      </Box>

      <DialogContent sx={{ p: 3 }}>
        <Alert severity="info" icon={false} sx={{ mb: 2.5, borderRadius: 2, fontSize: '0.82rem' }}>
          You can edit <strong>description</strong> and optionally replace the file. Module cannot be changed.
        </Alert>

        <TextField
          label="Description" fullWidth multiline rows={3} value={description} sx={{ mb: 3 }}
          onChange={e => setDescription(e.target.value)}
          InputProps={{ sx: { borderRadius: 2 } }}
        />

        <Box sx={{ border: `1.5px dashed ${COLORS.border}`, borderRadius: 2, p: 2 }}>
          <Typography variant="body2" color={COLORS.textMuted} mb={1.5} fontWeight={500}>
            Current file:{' '}
            {assessment?.url
              ? <Box component="a" href={assessment.url} target="_blank" rel="noreferrer"
                  sx={{ color: COLORS.primary, fontWeight: 600 }}>View current file ↗</Box>
              : 'No file attached'}
          </Typography>
          <TextField
            type="file" fullWidth variant="outlined"
            InputLabelProps={{ shrink: true }}
            label={uploading ? "Uploading…" : "Replace File (optional)"}
            disabled={uploading}
            InputProps={{ sx: { borderRadius: 2 } }}
            onChange={e => {
              const file = e.target.files[0];
              if (file && file.size > 8 * 1024 * 1024) {
                e.target.value = "";
                toast.error("File size must be less than 8MB.");
              } else handleFileChange(e);
            }}
          />
          {uploading && <LinearProgress sx={{ mt: 1, borderRadius: 1 }} />}
          {fileUploaded && (
            <Box display="flex" alignItems="center" gap={.5} mt={1}>
              <CheckCircleIcon sx={{ fontSize: 16, color: COLORS.success }} />
              <Typography variant="caption" color={COLORS.success} fontWeight={600}>
                New file ready to save
              </Typography>
            </Box>
          )}
        </Box>
      </DialogContent>

      <DialogActions sx={{ p: 2.5, borderTop: `1px solid ${COLORS.border}`, gap: 1 }}>
        <Button onClick={onClose} variant="outlined" color="error"
          sx={{ borderRadius: 2, textTransform: 'none', fontWeight: 600 }}>
          Cancel
        </Button>
        <Button onClick={handleSave} variant="contained" disabled={saving}
          sx={{ borderRadius: 2, textTransform: 'none', fontWeight: 600, px: 3 }}>
          {saving ? <><CircularProgress size={16} sx={{ mr: 1 }} />Saving…</> : 'Save Changes'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

// ─────────────────────────────────────────────────────────────────
// Quiz Edit Dialog — description + question text only
// ─────────────────────────────────────────────────────────────────
const QuizEditDialog = ({ open, onClose, assessment, onSaved }) => {
  const [description, setDescription] = useState('');
  const [questions, setQuestions]     = useState([]);
  const [loading, setLoading]         = useState(false);
  const [saving, setSaving]           = useState(false);

  useEffect(() => {
    if (open && assessment) {
      setDescription(assessment.description || '');
      fetchQuestions();
    }
  }, [open, assessment]);

  const fetchQuestions = async () => {
    setLoading(true);
    try {
      const res = await axios.get(`assessment_questions/${assessment.id}`);
      setQuestions(res.data);
    } catch {
      toast.error("Failed to load questions");
    } finally {
      setLoading(false);
    }
  };

  const handleSave = async () => {
    if (!description.trim()) { toast.error("Description is required"); return; }
    setSaving(true);
    try {
      await axios.put(`trent_assessments/${assessment.id}`, {
        batchId: assessment.batchId,
        moduleName: assessment.moduleName,
        description,
        url: assessment.url,
        assessmentType: 'QUIZ',
      });
      for (const q of questions) {
        await axios.put(`assessment_questions/${q.id}`, {
          trentAssessmentId: assessment.id,
          questionText: q.questionText,
          questionType: q.questionType,
          marks: q.marks,
          orderIndex: q.orderIndex,
          options: q.options || [],
          matchPairs: q.matchPairs || [],
        });
      }
      toast.success("Quiz updated successfully");
      onSaved();
      onClose();
    } catch {
      toast.error("Failed to update quiz");
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth
      PaperProps={{ sx: { borderRadius: 3, maxHeight: '90vh' } }}>

      <Box sx={{ background: 'linear-gradient(135deg,#7c3aed 0%,#6366f1 100%)', px: 3, py: 2.5 }}>
        <Box display="flex" alignItems="center" gap={1.5}>
          <Avatar sx={{ backgroundColor: 'rgba(255,255,255,.2)', width: 38, height: 38 }}>
            <EditIcon sx={{ color: '#fff', fontSize: 20 }} />
          </Avatar>
          <Box>
            <Typography variant="h6" fontWeight={700} color="#fff">Edit Quiz Assessment</Typography>
            <Typography variant="body2" sx={{ color: 'rgba(255,255,255,.75)' }}>
              Module: {assessment?.moduleName}
            </Typography>
          </Box>
        </Box>
      </Box>

      <DialogContent sx={{ p: 3, backgroundColor: COLORS.bg }}>
        <Alert severity="info" icon={false} sx={{ mb: 2.5, borderRadius: 2, fontSize: '0.82rem' }}>
          You can edit <strong>description</strong> and <strong>question text</strong>.
          Options and correct answers are <strong>locked</strong> to preserve result integrity.
        </Alert>

        <TextField
          label="Description" fullWidth multiline rows={2} value={description} sx={{ mb: 3 }}
          onChange={e => setDescription(e.target.value)}
          InputProps={{ sx: { borderRadius: 2, backgroundColor: '#fff' } }}
        />

        {loading ? (
          <Box display="flex" justifyContent="center" py={4}>
            <CircularProgress />
          </Box>
        ) : questions.map((q, qIdx) => {
          const meta = TYPE_META[q.questionType] || TYPE_META.MCQ;
          return (
            <Box key={q.id} sx={{
              border: `1.5px solid ${meta.color}33`,
              backgroundColor: '#fff',
              borderRadius: 2, p: 2.5, mb: 2,
            }}>
              <Box display="flex" gap={1} alignItems="center" mb={1.5} flexWrap="wrap">
                <Avatar sx={{ width: 24, height: 24, fontSize: '0.7rem', fontWeight: 700,
                  backgroundColor: meta.color, color: '#fff' }}>
                  {qIdx + 1}
                </Avatar>
                <Chip label={meta.label} size="small"
                  sx={{ backgroundColor: meta.color, color: '#fff', fontWeight: 600, fontSize: '0.7rem' }} />
                <MarksBadge marks={q.marks || 0} />
                <Typography variant="caption" color={COLORS.textMuted} sx={{ ml: 'auto' }}>
                  Question text editable — options locked
                </Typography>
              </Box>

              <TextField
                label={`Question ${qIdx + 1} Text`}
                fullWidth multiline rows={2} size="small"
                value={q.questionText}
                onChange={e => {
                  const updated = [...questions];
                  updated[qIdx] = { ...updated[qIdx], questionText: e.target.value };
                  setQuestions(updated);
                }}
                InputProps={{ sx: { borderRadius: 2 } }}
                sx={{ mb: 1.5 }}
              />

              {/* Read-only options preview */}
              {(q.questionType === 'MCQ' || q.questionType === 'TRUE_FALSE') && q.options?.length > 0 && (
                <Box sx={{ backgroundColor: '#f8fafc', borderRadius: 2, p: 1.5,
                  border: `1px solid ${COLORS.border}` }}>
                  <Typography variant="caption" color={COLORS.textMuted} fontWeight={700}
                    sx={{ display: 'block', mb: 1, letterSpacing: '.05em' }}>
                    OPTIONS (read-only)
                  </Typography>
                  <Stack spacing={.5}>
                    {q.options.map((opt, i) => (
                      <Box key={i} display="flex" alignItems="center" gap={1}>
                        <Box sx={{
                          width: 8, height: 8, borderRadius: '50%', flexShrink: 0,
                          backgroundColor: opt.isCorrect ? COLORS.success : '#cbd5e1',
                        }} />
                        <Typography variant="caption" sx={{
                          color: opt.isCorrect ? COLORS.success : COLORS.textMuted,
                          fontWeight: opt.isCorrect ? 700 : 400,
                        }}>
                          {opt.optionText} {opt.isCorrect ? '✓' : ''}
                        </Typography>
                      </Box>
                    ))}
                  </Stack>
                </Box>
              )}

              {q.questionType === 'MATCH' && q.matchPairs?.length > 0 && (
                <Box sx={{ backgroundColor: '#f5f3ff', borderRadius: 2, p: 1.5,
                  border: '1px solid #ddd6fe' }}>
                  <Typography variant="caption" color={COLORS.textMuted} fontWeight={700}
                    sx={{ display: 'block', mb: 1, letterSpacing: '.05em' }}>
                    MATCH PAIRS (read-only)
                  </Typography>
                  {q.matchPairs.map((pair, i) => (
                    <Typography key={i} variant="caption" display="block" mt={.5} color="#5b21b6">
                      {pair.leftItem} → {pair.rightItem}
                    </Typography>
                  ))}
                </Box>
              )}
            </Box>
          );
        })}
      </DialogContent>

      <DialogActions sx={{ p: 2.5, borderTop: `1px solid ${COLORS.border}`, gap: 1 }}>
        <Button onClick={onClose} variant="outlined" color="error"
          sx={{ borderRadius: 2, textTransform: 'none', fontWeight: 600 }}>
          Cancel
        </Button>
        <Button onClick={handleSave} variant="contained" disabled={saving}
          sx={{ borderRadius: 2, textTransform: 'none', fontWeight: 600, px: 3 }}>
          {saving ? <><CircularProgress size={16} sx={{ mr: 1 }} />Saving…</> : 'Save Changes'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

// ─────────────────────────────────────────────────────────────────
// Question Card Builder (used inside the create modal)
// ─────────────────────────────────────────────────────────────────
const QuestionCard = ({ q, qIdx, onUpdate, onRemove, onAddOption, onRemoveOption,
  onUpdateOption, onAddPair, onRemovePair, onUpdatePair }) => {

  const meta = TYPE_META[q.questionType] || TYPE_META.MCQ;
  const [marksInput, setMarksInput] = useState(String(q.marks ?? 1));
  return (
    <Box sx={{
      border: `2px solid ${meta.color}44`,
      borderRadius: 3,
      backgroundColor: '#fff',
      overflow: 'hidden',
      mb: 2,
      boxShadow: '0 2px 8px rgba(0,0,0,.04)',
    }}>
      {/* Card header bar */}
      <Box sx={{
        backgroundColor: meta.color,
        px: 2, py: 1.25,
        display: 'flex', alignItems: 'center', justifyContent: 'space-between',
      }}>
        <Box display="flex" alignItems="center" gap={1}>
          <DragIndicatorIcon sx={{ color: 'rgba(255,255,255,.6)', fontSize: 18 }} />
          <Typography variant="body2" fontWeight={700} color="#fff">
            Question {qIdx + 1}
          </Typography>
          <Chip label={meta.label} size="small"
            sx={{ backgroundColor: 'rgba(255,255,255,.2)', color: '#fff',
              fontWeight: 600, fontSize: '0.68rem', height: 20 }} />
        </Box>
        <Tooltip title="Remove question">
          <IconButton size="small" onClick={() => onRemove(qIdx)}
            sx={{ color: 'rgba(255,255,255,.8)', '&:hover': { backgroundColor: 'rgba(255,255,255,.15)' } }}>
            <DeleteIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      </Box>

      <Box sx={{ p: 2.5 }}>
        {/* Type + Marks row */}
        <Box display="flex" gap={2} mb={2}>
          <TextField
            select label="Question Type" size="small"
            value={q.questionType} sx={{ flex: 2 }}
            onChange={e => onUpdate(qIdx, 'questionType', e.target.value)}
            InputProps={{ sx: { borderRadius: 2 } }}
          >
            {Object.entries(TYPE_META).map(([type, m]) => (
              <MenuItem key={type} value={type}>
                <Box display="flex" alignItems="center" gap={1}>
                  <Box sx={{ width: 10, height: 10, borderRadius: '50%', backgroundColor: m.color }} />
                  {m.label}
                </Box>
              </MenuItem>
            ))}
          </TextField>

<TextField
            label="Marks" size="small"
            value={marksInput} sx={{ width: 100 }}
            inputProps={{ inputMode: 'numeric', pattern: '[0-9]*' }}
            InputProps={{
              sx: { borderRadius: 2 },
              endAdornment: <InputAdornment position="end">
                <Typography variant="caption" color={COLORS.textMuted}>pts</Typography>
              </InputAdornment>
            }}
            onKeyDown={e => {
              if (['-', '+', '.', 'e', 'E'].includes(e.key)) e.preventDefault();
            }}
            onChange={e => {
              const raw = e.target.value.replace(/[^0-9]/g, '');
              setMarksInput(raw); // allow empty string while typing
            }}
            onBlur={() => {
              const num = Math.min(100, Math.max(1, parseInt(marksInput) || 1));
              setMarksInput(String(num));
              onUpdate(qIdx, 'marks', num);
            }}
          />
        </Box>

        {/* Question text */}
        <TextField
          label="Question Text" fullWidth multiline rows={2} size="small"
          value={q.questionText} sx={{ mb: 2 }}
          InputProps={{ sx: { borderRadius: 2 } }}
          onChange={e => onUpdate(qIdx, 'questionText', e.target.value)}
        />

        {/* MCQ options */}
        {q.questionType === 'MCQ' && (
          <Box sx={{ backgroundColor: '#eff6ff', borderRadius: 2, p: 2,
            border: `1px solid #bfdbfe` }}>
            <Typography variant="caption" fontWeight={700} color={COLORS.MCQ}
              sx={{ display: 'block', mb: 1.5, letterSpacing: '.05em' }}>
              OPTIONS — click radio (●) to mark correct answer
            </Typography>
            {q.options.map((opt, oIdx) => (
              <Box key={oIdx} display="flex" alignItems="center" gap={1} mb={1} sx={{
                backgroundColor: opt.isCorrect ? '#dbeafe' : 'transparent',
                borderRadius: 1.5, px: 1, py: .5,
                border: `1px solid ${opt.isCorrect ? '#93c5fd' : 'transparent'}`,
                transition: 'all .15s',
              }}>
                <Tooltip title="Mark as correct">
                  <Radio size="small" checked={opt.isCorrect}
                    onChange={() => onUpdateOption(qIdx, oIdx, 'isCorrect', true)}
                    sx={{ color: COLORS.MCQ, p: .5 }} />
                </Tooltip>
                <TextField size="small" fullWidth
                  placeholder={`Option ${oIdx + 1}`}
                  value={opt.optionText}
                  InputProps={{ sx: { borderRadius: 1.5, backgroundColor: '#fff' } }}
                  onChange={e => onUpdateOption(qIdx, oIdx, 'optionText', e.target.value)} />
                {q.options.length > 2 && (
                  <Tooltip title="Remove option">
                    <IconButton size="small" color="error"
                      onClick={() => onRemoveOption(qIdx, oIdx)}>
                      <DeleteIcon fontSize="small" />
                    </IconButton>
                  </Tooltip>
                )}
              </Box>
            ))}
            <Button size="small" startIcon={<AddIcon />}
              onClick={() => onAddOption(qIdx)}
              sx={{ mt: .5, textTransform: 'none', fontWeight: 600, color: COLORS.MCQ }}>
              Add Option
            </Button>
          </Box>
        )}

        {/* TRUE/FALSE */}
        {q.questionType === 'TRUE_FALSE' && (
          <Box sx={{ backgroundColor: '#f0fdf4', borderRadius: 2, p: 2,
            border: '1px solid #bbf7d0' }}>
            <Typography variant="caption" fontWeight={700} color={COLORS.TRUE_FALSE}
              sx={{ display: 'block', mb: 1.5, letterSpacing: '.05em' }}>
              SELECT CORRECT ANSWER
            </Typography>
            <RadioGroup row
              value={q.options.find(o => o.isCorrect)?.optionText || 'True'}
              onChange={e => onUpdate(qIdx, '__trueFalse', e.target.value)}>
              {['True', 'False'].map(val => (
                <FormControlLabel key={val} value={val}
                  control={<Radio sx={{ color: COLORS.TRUE_FALSE }} />}
                  label={
                    <Box sx={{
                      border: `2px solid ${q.options.find(o => o.isCorrect)?.optionText === val
                        ? COLORS.TRUE_FALSE : COLORS.border}`,
                      borderRadius: 2, px: 2.5, py: 1, mr: 1,
                      backgroundColor: q.options.find(o => o.isCorrect)?.optionText === val
                        ? '#dcfce7' : '#fff',
                      transition: 'all .15s',
                    }}>
                      <Typography fontWeight={700} fontSize="0.9rem"
                        color={q.options.find(o => o.isCorrect)?.optionText === val
                          ? COLORS.TRUE_FALSE : COLORS.textMuted}>
                        {val === 'True' ? '✓ True' : '✗ False'}
                      </Typography>
                    </Box>
                  } />
              ))}
            </RadioGroup>
          </Box>
        )}

        {/* MATCH */}
        {q.questionType === 'MATCH' && (
          <Box sx={{ backgroundColor: '#f5f3ff', borderRadius: 2, p: 2,
            border: '1px solid #ddd6fe' }}>
            <Typography variant="caption" fontWeight={700} color={COLORS.MATCH}
              sx={{ display: 'block', mb: 1.5, letterSpacing: '.05em' }}>
              MATCH PAIRS — Left column → Right column
            </Typography>
            {q.matchPairs.map((pair, pIdx) => (
              <Box key={pIdx} display="flex" alignItems="center" gap={1} mb={1}>
                <TextField size="small" placeholder="Left item" value={pair.leftItem}
                  sx={{ flex: 1 }} InputProps={{ sx: { borderRadius: 2, backgroundColor: '#fff' } }}
                  onChange={e => onUpdatePair(qIdx, pIdx, 'leftItem', e.target.value)} />
                <Chip label="→" size="small"
                  sx={{ backgroundColor: COLORS.MATCH, color: '#fff', fontWeight: 700, flexShrink: 0 }} />
                <TextField size="small" placeholder="Right item" value={pair.rightItem}
                  sx={{ flex: 1 }} InputProps={{ sx: { borderRadius: 2, backgroundColor: '#fff' } }}
                  onChange={e => onUpdatePair(qIdx, pIdx, 'rightItem', e.target.value)} />
                {q.matchPairs.length > 1 && (
                  <Tooltip title="Remove pair">
                    <IconButton size="small" color="error"
                      onClick={() => onRemovePair(qIdx, pIdx)}>
                      <DeleteIcon fontSize="small" />
                    </IconButton>
                  </Tooltip>
                )}
              </Box>
            ))}
            <Button size="small" startIcon={<AddIcon />}
              onClick={() => onAddPair(qIdx)}
              sx={{ mt: .5, textTransform: 'none', fontWeight: 600, color: COLORS.MATCH }}>
              Add Pair
            </Button>
          </Box>
        )}

        {/* SHORT ANSWER */}
        {q.questionType === 'SHORT_ANSWER' && (
          <Box sx={{ backgroundColor: '#fffbeb', borderRadius: 2, p: 2,
            border: '1px solid #fde68a' }}>
            <Typography variant="body2" color="#92400e" mb={1.5}
              display="flex" alignItems="center" gap={.5}>
              <EmojiObjectsIcon fontSize="small" />
              Student types a free-text answer. Graded manually by the teacher.
            </Typography>
            <TextField
              label="Model Answer / Marking Guide (teacher reference only)"
              fullWidth multiline rows={2} size="small"
              placeholder="Enter expected answer or marking criteria…"
              helperText="Only visible to the teacher when grading. Not shown to students."
              InputProps={{ sx: { borderRadius: 2, backgroundColor: '#fff' } }}
            />
          </Box>
        )}
      </Box>
    </Box>
  );
};

// ─────────────────────────────────────────────────────────────────
// MAIN APP
// ─────────────────────────────────────────────────────────────────
const App = () => {
  const { id: encodedBatchId } = useParams();
  const id = decryptData(encodedBatchId);

  const [rows, setRows]               = useState([]);
  const [open, setOpen]               = useState(false);
  const [page, setPage]               = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [batchData, setBatchData]     = useState(null);
  const [fileUploaded, setFileUploaded] = useState(false);
  const [fileUploading, setFileUploading] = useState(false);

  const [step, setStep]                       = useState('form');

  const [formData, setFormData] = useState({
    description: '', moduleName: '', url: '', assessmentType: 'FILE',
  });

  const [questions, setQuestions] = useState([]);

  const [fileEditOpen, setFileEditOpen]   = useState(false);
  const [quizEditOpen, setQuizEditOpen]   = useState(false);
  const [viewQuizOpen, setViewQuizOpen]   = useState(false);
  const [selectedAssessment, setSelectedAssessment] = useState(null);

  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [deleteTarget, setDeleteTarget]         = useState(null);
  const [deleteError, setDeleteError]           = useState('');
  const [deleteChecking, setDeleteChecking]     = useState(false);

  // ── Navigation guard: warn before closing tab on step 2 ──────
  useEffect(() => {
    const handler = (e) => {
      if (step === 'questions') {
        e.preventDefault();
        e.returnValue = '';
      }
    };
    window.addEventListener('beforeunload', handler);
    return () => window.removeEventListener('beforeunload', handler);
  }, [step]);

  useEffect(() => {
    fetchBatchData();
    fetchAssessmentData();
  }, []);

  const resetModal = () => {
    setFormData({ description: '', moduleName: '', url: '', assessmentType: 'FILE' });
    setQuestions([]);
    setStep('form');
    setFileUploaded(false);
    setFileUploading(false);
  };

const handleClose = () => {
  if (step === 'questions' && questions.length > 0) {
    const confirmed = window.confirm(
      "You have unsaved questions. Nothing has been saved yet.\n\nDo you want to discard and close?"
    );
    if (!confirmed) return;
  }
  setOpen(false);
  resetModal();
};

  const handleOpen = () => { resetModal(); setOpen(true); };

  const fetchBatchData = async () => {
    try {
      const res = await axios.get(`batch/${id}`);
      setBatchData(res.data);
    } catch (err) { console.error(err); }
  };

  const fetchAssessmentData = async () => {
    try {
      const res = await axios.get(`trent_assessments/${id}`);
      setRows(res.data);
    } catch (err) { console.error(err); }
  };

  // ── Delete with submission check ─────────────────────────────
  const handleDeleteClick = async (row) => {
    setDeleteTarget(row);
    setDeleteError('');
    setDeleteChecking(true);
    setDeleteDialogOpen(true);
    try {
      const res = await axios.get(
        row.assessmentType === 'QUIZ'
          ? `quiz/submissions/count/${row.id}`
          : `submissions/${row.id}`
      );
      const count = row.assessmentType === 'QUIZ'
        ? (res.data?.count ?? res.data?.length ?? res.data ?? 0)
        : (Array.isArray(res.data) ? res.data.length : 0);
      if (count > 0) {
        setDeleteError(
          `Cannot delete: ${count} student submission${count > 1 ? 's' : ''} reference this assessment. Remove all submissions first.`
        );
      }
    } catch {
      console.warn("Could not check submissions — allowing delete");
    } finally {
      setDeleteChecking(false);
    }
  };

  const confirmDelete = async () => {
    if (deleteError) return;
    try {
      await axios.delete(`trent_assessments/${deleteTarget.id}`);
      setRows(prev => prev.filter(r => r.id !== deleteTarget.id));
      toast.success("Assessment deleted successfully");
    } catch {
      toast.error("Delete failed");
    } finally {
      setDeleteDialogOpen(false);
      setDeleteTarget(null);
    }
  };

  const handleEditClick = (row) => {
    setSelectedAssessment({ ...row, batchId: id });
    row.assessmentType === 'QUIZ' ? setQuizEditOpen(true) : setFileEditOpen(true);
  };

  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setFileUploading(true);
    const fd = new FormData();
    fd.append('file', file);
    fd.append('upload_preset', CLOUDINARY_UPLOAD_PRESET);
    fd.append('public_id', `LMS/Trent/${file.name} - ${timestamp}`);
    try {
      const res  = await fetch(baseURL, { method: 'POST', body: fd });
      const data = await res.json();
      if (data.secure_url) {
        setFormData(prev => ({ ...prev, url: data.secure_url }));
        setFileUploaded(true);
        toast.success("File uploaded successfully");
      }
    } catch {
      toast.error("File upload failed");
    } finally {
      setFileUploading(false);
    }
  };

// ── Step 1: For QUIZ → just advance to questions step (no API call yet)
//            For FILE → save as before (unchanged)
const handleSaveAssessment = async () => {
  if (!formData.moduleName || !formData.description) {
    toast.error("Please fill in Module and Description");
    return;
  }
  if (formData.assessmentType === 'FILE' && !fileUploaded) {
    toast.error("Please upload a file before saving");
    return;
  }

  if (formData.assessmentType === 'QUIZ') {
    // ── No API call here anymore — just advance to step 2 ──
    setStep('questions');
    return;
  }

  // ── FILE: unchanged behaviour ──
  const payload = {
    batchId: id,
    description: formData.description,
    moduleName: formData.moduleName,
    url: formData.url,
    assessmentType: 'FILE',
  };
  try {
    await axios.post('trent_assessments/upload', payload);
    toast.success("Assessment created successfully");
    fetchAssessmentData();
    setOpen(false);
    resetModal();
  } catch {
    toast.error("Failed to save assessment");
  }
};

// ── Step 2: Submit assessment + all questions in one transaction ──
const handleSaveAllQuestions = async () => {
  if (questions.length === 0) {
    toast.error("Please add at least one question before saving");
    return;
  }
  for (let i = 0; i < questions.length; i++) {
    const q = questions[i];
    if (!q.questionText.trim()) { toast.error(`Question ${i + 1}: text cannot be empty`); return; }
    if (q.questionType === 'MCQ') {
      const filled = q.options.filter(o => o.optionText.trim());
      if (filled.length < 2) { toast.error(`Question ${i + 1}: add at least 2 options`); return; }
      if (!q.options.some(o => o.isCorrect)) { toast.error(`Question ${i + 1}: select a correct answer`); return; }
    }
    if (q.questionType === 'MATCH' && q.matchPairs.length < 1) {
      toast.error(`Question ${i + 1}: add at least 1 match pair`); return;
    }
  }

  const payload = {
    batchId: id,
    moduleName: formData.moduleName,
    description: formData.description,
    assessmentType: 'QUIZ',
    url: '',
    questions: questions.map(q => ({
      questionText: q.questionText,
      questionType: q.questionType,
      marks: q.marks,
      orderIndex: q.orderIndex,
      options: (q.questionType === 'MCQ' || q.questionType === 'TRUE_FALSE') ? q.options : [],
      matchPairs: q.questionType === 'MATCH' ? q.matchPairs : [],
    })),
  };

  try {
    await axios.post('assessment_questions/create-quiz', payload);
    toast.success(`Quiz created with ${questions.length} question(s)!`);
    setOpen(false);
    resetModal();
    fetchAssessmentData();
  } catch {
    toast.error("Failed to create quiz");
  }
};

  // ── Question helpers ──────────────────────────────────────────
  const addQuestion = () => {
    setQuestions(prev => [...prev, {
      questionText: '', questionType: 'MCQ',
      marks: 1,                           // FIXED: default 1 mark, fully editable
      orderIndex: prev.length + 1,
      options: [
        { optionText: '', isCorrect: false },
        { optionText: '', isCorrect: false },
        { optionText: '', isCorrect: false },
        { optionText: '', isCorrect: false },
      ],
      matchPairs: [],
    }]);
  };

  const removeQuestion = (qIdx) => setQuestions(prev => prev.filter((_, i) => i !== qIdx));

  const updateQuestion = (qIdx, field, value) => {
    setQuestions(prev => {
      const updated = [...prev];
      if (field === '__trueFalse') {
        updated[qIdx] = {
          ...updated[qIdx],
          options: [
            { optionText: 'True',  isCorrect: value === 'True' },
            { optionText: 'False', isCorrect: value === 'False' },
          ],
        };
        return updated;
      }
      updated[qIdx] = { ...updated[qIdx], [field]: value };
      if (field === 'questionType') {
        if (value === 'TRUE_FALSE') {
          updated[qIdx].options = [
            { optionText: 'True', isCorrect: true },
            { optionText: 'False', isCorrect: false },
          ];
          updated[qIdx].matchPairs = [];
        } else if (value === 'MCQ') {
          updated[qIdx].options = [
            { optionText: '', isCorrect: false },
            { optionText: '', isCorrect: false },
            { optionText: '', isCorrect: false },
            { optionText: '', isCorrect: false },
          ];
          updated[qIdx].matchPairs = [];
        } else if (value === 'MATCH') {
          updated[qIdx].options = [];
          updated[qIdx].matchPairs = [
            { leftItem: '', rightItem: '' },
            { leftItem: '', rightItem: '' },
          ];
        } else if (value === 'SHORT_ANSWER') {
          updated[qIdx].options = [];
          updated[qIdx].matchPairs = [];
        }
      }
      return updated;
    });
  };

  const updateOption = (qIdx, oIdx, field, value) => {
    setQuestions(prev => {
      const updated = [...prev];
      const opts = [...updated[qIdx].options];
      if (field === 'isCorrect') {
        opts.forEach((o, i) => { opts[i] = { ...o, isCorrect: i === oIdx }; });
      } else {
        opts[oIdx] = { ...opts[oIdx], [field]: value };
      }
      updated[qIdx].options = opts;
      return updated;
    });
  };

  const addOption = (qIdx) => setQuestions(prev => {
    const updated = [...prev];
    updated[qIdx].options.push({ optionText: '', isCorrect: false });
    return updated;
  });

  const removeOption = (qIdx, oIdx) => setQuestions(prev => {
    const updated = [...prev];
    updated[qIdx].options = updated[qIdx].options.filter((_, i) => i !== oIdx);
    return updated;
  });

  const updateMatchPair = (qIdx, pIdx, field, value) => {
    setQuestions(prev => {
      const updated = [...prev];
      const pairs = [...updated[qIdx].matchPairs];
      pairs[pIdx] = { ...pairs[pIdx], [field]: value };
      updated[qIdx].matchPairs = pairs;
      return updated;
    });
  };

  const addMatchPair = (qIdx) => setQuestions(prev => {
    const updated = [...prev];
    updated[qIdx].matchPairs.push({ leftItem: '', rightItem: '' });
    return updated;
  });

  const removeMatchPair = (qIdx, pIdx) => setQuestions(prev => {
    const updated = [...prev];
    updated[qIdx].matchPairs = updated[qIdx].matchPairs.filter((_, i) => i !== pIdx);
    return updated;
  });

  const isSaveDisabled = () => {
    if (!formData.description.trim() || !formData.moduleName) return true;
    if (formData.assessmentType === 'FILE' && !fileUploaded) return true;
    return false;
  };

  const totalQuestionsMarks = questions.reduce((s, q) => s + (Number(q.marks) || 0), 0);

  // ─────────────────────────────────────────────────────────────
  // RENDER
  // ─────────────────────────────────────────────────────────────
  return (
    <Box sx={{ backgroundColor: COLORS.bg, minHeight: '100vh' }}>
      <Header />

      <Box sx={{ maxWidth: 1200, mx: 'auto', px: { xs: 2, md: 4 }, py: 4 }}>

        {/* Page header */}
        <Box display="flex" alignItems="center" justifyContent="space-between" mb={3} flexWrap="wrap" gap={2}>
          <Box display="flex" alignItems="center" gap={2}>
            <Avatar sx={{ backgroundColor: COLORS.primary, width: 44, height: 44 }}>
              <SchoolIcon />
            </Avatar>
            <Box>
              <Typography variant="h5" fontWeight={800} color={COLORS.textPrimary}>
                Assessments
              </Typography>
              <Typography variant="body2" color={COLORS.textMuted}>
                Manage quizzes and file assessments for this batch
              </Typography>
            </Box>
          </Box>
          <Stack direction="row" spacing={1.5}>
            <Link to="/Allcourse" style={{ textDecoration: 'none' }}>
              <Button variant="outlined" startIcon={<ArrowBackIcon />}
                sx={{ borderRadius: 2, textTransform: 'none', fontWeight: 600,
                  borderColor: COLORS.border, color: COLORS.textMuted,
                  '&:hover': { borderColor: COLORS.primary, color: COLORS.primary } }}>
                All Courses
              </Button>
            </Link>
            <Button variant="contained" startIcon={<AddIcon />} onClick={handleOpen}
              sx={{ borderRadius: 2, textTransform: 'none', fontWeight: 700,
                background: 'linear-gradient(135deg,#1a56db,#6366f1)',
                boxShadow: '0 4px 14px rgba(26,86,219,.35)',
                '&:hover': { boxShadow: '0 6px 20px rgba(26,86,219,.45)' } }}>
              New Assessment
            </Button>
          </Stack>
        </Box>

        {/* Stats row */}
        {rows.length > 0 && (
          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} mb={3}>
            {[
              { label: 'Total', value: rows.length, color: COLORS.primary, bg: '#eff6ff' },
              { label: 'Quizzes', value: rows.filter(r => r.assessmentType === 'QUIZ').length, color: COLORS.MATCH, bg: '#f5f3ff' },
              { label: 'File Uploads', value: rows.filter(r => r.assessmentType !== 'QUIZ').length, color: COLORS.MCQ, bg: '#eff6ff' },
            ].map(stat => (
              <Box key={stat.label} sx={{
                ...sxCard, px: 2.5, py: 1.75, flex: 1,
                borderLeft: `4px solid ${stat.color}`,
              }}>
                <Typography variant="h4" fontWeight={800} color={stat.color}>{stat.value}</Typography>
                <Typography variant="body2" color={COLORS.textMuted} fontWeight={500}>{stat.label}</Typography>
              </Box>
            ))}
          </Stack>
        )}

        {/* Table */}
        <Paper sx={{ ...sxCard, overflow: 'hidden' }}>
          <Table>
            <TableHead sx={sxTableHead}>
              <TableRow>
                <TableCell>Description</TableCell>
                <TableCell>Type</TableCell>
                <TableCell>Module</TableCell>
                <TableCell>Created</TableCell>
                <TableCell align="right">Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {rows.length > 0 ? (
                rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row, index) => (
                  <TableRow key={index} hover sx={{
                    '&:hover': { backgroundColor: '#f8fafc' },
                    '& td': { py: 1.75, borderBottom: `1px solid ${COLORS.border}` },
                  }}>
                    <TableCell>
                      <Typography variant="body2" fontWeight={600} color={COLORS.textPrimary}>
                        {row.description}
                      </Typography>
                    </TableCell>
                    <TableCell>
                      {row.assessmentType === 'QUIZ' ? (
                        <Chip label="Quiz" size="small" icon={<QuizIcon style={{ fontSize: 14 }} />}
                          sx={{ backgroundColor: '#f5f3ff', color: COLORS.MATCH,
                            fontWeight: 700, fontSize: '0.72rem',
                            border: `1px solid ${COLORS.MATCH}44` }} />
                      ) : (
                        <Chip label="File" size="small" icon={<UploadFileIcon style={{ fontSize: 14 }} />}
                          sx={{ backgroundColor: '#eff6ff', color: COLORS.MCQ,
                            fontWeight: 700, fontSize: '0.72rem',
                            border: `1px solid ${COLORS.MCQ}44` }} />
                      )}
                    </TableCell>
                    <TableCell>
                      <Chip label={row.moduleName} size="small"
                        sx={{ backgroundColor: '#f1f5f9', color: COLORS.textMuted,
                          fontWeight: 600, fontSize: '0.72rem' }} />
                    </TableCell>
                    <TableCell>
                      <Typography variant="caption" color={COLORS.textMuted}>
                        {row.createdAt ? format(new Date(row.createdAt), 'dd MMM yyyy, HH:mm') : 'N/A'}
                      </Typography>
                    </TableCell>
                    <TableCell align="right">
                      <Stack direction="row" spacing={.75} justifyContent="flex-end">
                        {row.assessmentType === 'QUIZ' ? (
                          <Tooltip title="Preview quiz">
                            <Button size="small" variant="outlined" startIcon={<VisibilityIcon />}
                              onClick={() => { setSelectedAssessment(row); setViewQuizOpen(true); }}
                              sx={{ borderRadius: 1.5, textTransform: 'none', fontWeight: 600,
                                fontSize: '0.75rem', borderColor: '#bfdbfe', color: COLORS.MCQ,
                                '&:hover': { backgroundColor: '#eff6ff' } }}>
                              View
                            </Button>
                          </Tooltip>
                        ) : (
                          <Tooltip title="Open file">
                            <Button size="small" variant="outlined"
                              startIcon={<UploadFileIcon />}
                              onClick={() => window.open(row.url, '_blank')}
                              sx={{ borderRadius: 1.5, textTransform: 'none', fontWeight: 600,
                                fontSize: '0.75rem', borderColor: '#bfdbfe', color: COLORS.MCQ,
                                '&:hover': { backgroundColor: '#eff6ff' } }}>
                              File
                            </Button>
                          </Tooltip>
                        )}
                        <Tooltip title="Edit">
                          <Button size="small" variant="outlined" startIcon={<EditIcon />}
                            onClick={() => handleEditClick(row)}
                            sx={{ borderRadius: 1.5, textTransform: 'none', fontWeight: 600,
                              fontSize: '0.75rem', borderColor: '#bbf7d0', color: COLORS.success,
                              '&:hover': { backgroundColor: '#f0fdf4' } }}>
                            Edit
                          </Button>
                        </Tooltip>
                        <Tooltip title="Delete">
                          <Button size="small" variant="outlined" startIcon={<DeleteIcon />}
                            onClick={() => handleDeleteClick(row)}
                            sx={{ borderRadius: 1.5, textTransform: 'none', fontWeight: 600,
                              fontSize: '0.75rem', borderColor: '#fecaca', color: COLORS.error,
                              '&:hover': { backgroundColor: '#fef2f2' } }}>
                            Delete
                          </Button>
                        </Tooltip>
                      </Stack>
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={5} align="center" sx={{ py: 8 }}>
                    <SchoolIcon sx={{ fontSize: 52, color: COLORS.border, mb: 1 }} />
                    <Typography color={COLORS.textMuted} fontWeight={500}>
                      No assessments yet
                    </Typography>
                    <Typography variant="body2" color={COLORS.textMuted} mt={.5}>
                      Click "New Assessment" to get started
                    </Typography>
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
          <TablePagination rowsPerPageOptions={[5, 10, 15]} component="div"
            count={rows.length} rowsPerPage={rowsPerPage} page={page}
            onPageChange={(e, n) => setPage(n)}
            onRowsPerPageChange={e => { setRowsPerPage(parseInt(e.target.value, 10)); setPage(0); }}
            sx={{ borderTop: `1px solid ${COLORS.border}` }}
          />
        </Paper>
      </Box>

      {/* ── CREATE MODAL ──────────────────────────────────────── */}
      <Modal open={open} onClose={handleClose}>
        <Box sx={{
          position: 'absolute', top: '50%', left: '50%',
          transform: 'translate(-50%,-50%)',
          width: '95%', maxWidth: 780,
          maxHeight: '92vh', overflowY: 'auto',
          backgroundColor: COLORS.bg,
          borderRadius: 3,
          boxShadow: '0 20px 60px rgba(0,0,0,.2)',
          outline: 'none',
        }}>
          {/* Modal gradient header */}
          <Box sx={{
            background: step === 'form'
              ? 'linear-gradient(135deg,#1a56db 0%,#6366f1 100%)'
              : 'linear-gradient(135deg,#7c3aed 0%,#1a56db 100%)',
            px: 3, py: 2.5, borderRadius: '12px 12px 0 0',
          }}>
            <Box display="flex" alignItems="center" justifyContent="space-between">
              <Box display="flex" alignItems="center" gap={1.5}>
                <Avatar sx={{ backgroundColor: 'rgba(255,255,255,.2)', width: 40, height: 40 }}>
                  {step === 'form'
                    ? <AddIcon sx={{ color: '#fff' }} />
                    : <QuizIcon sx={{ color: '#fff' }} />}
                </Avatar>
                <Box>
                  <Typography variant="h6" fontWeight={700} color="#fff">
                    {step === 'form' ? 'New Assessment' : 'Add Questions'}
                  </Typography>
                  <Typography variant="body2" sx={{ color: 'rgba(255,255,255,.75)' }}>
 {step === 'form'
                      ? 'Choose type, select module and fill details'
                      : `${formData.description} · ${questions.length} question${questions.length !== 1 ? 's' : ''} · ${totalQuestionsMarks} marks`}
                  </Typography>
                </Box>
              </Box>
              {/* Step indicator */}
              <Box display="flex" gap={1}>
                {['form', 'questions'].map((s, i) => (
                  <Box key={s} sx={{
                    width: 28, height: 28, borderRadius: '50%',
                    backgroundColor: step === s ? '#fff' : 'rgba(255,255,255,.25)',
                    color: step === s ? COLORS.primary : '#fff',
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    fontSize: '0.75rem', fontWeight: 700,
                  }}>
                    {i + 1}
                  </Box>
                ))}
              </Box>
            </Box>
          </Box>

          <Box sx={{ p: 3 }}>
            {/* ── STEP 1: FORM ── */}
            {step === 'form' && (
              <Box>
                {/* Assessment type toggle */}
                <Box sx={{ ...sxCard, p: 2.5, mb: 3 }}>
                  <FormLabel sx={{ fontWeight: 700, color: COLORS.textPrimary, fontSize: '0.85rem',
                    letterSpacing: '.05em', textTransform: 'uppercase', display: 'block', mb: 1.5 }}>
                    Assessment Type
                  </FormLabel>
                  <Stack direction="row" spacing={2}>
                    {[
                      { value: 'FILE', label: 'File Upload', icon: <UploadFileIcon />, desc: 'Upload a PDF, doc, or any file' },
                      { value: 'QUIZ', label: 'Quiz', icon: <QuizIcon />, desc: 'MCQ, True/False, Match' },
                    ].map(opt => (
                      <Box key={opt.value} onClick={() => setFormData({ ...formData, assessmentType: opt.value })}
                        sx={{
                          flex: 1, border: `2px solid ${formData.assessmentType === opt.value ? COLORS.primary : COLORS.border}`,
                          borderRadius: 2, p: 2, cursor: 'pointer',
                          backgroundColor: formData.assessmentType === opt.value ? '#eff6ff' : '#fff',
                          transition: 'all .15s',
                          '&:hover': { borderColor: COLORS.primary, backgroundColor: '#eff6ff' },
                        }}>
                        <Box display="flex" alignItems="center" gap={1} mb={.5}>
                          <Box sx={{ color: formData.assessmentType === opt.value ? COLORS.primary : COLORS.textMuted }}>
                            {opt.icon}
                          </Box>
                          <Typography fontWeight={700} fontSize="0.9rem"
                            color={formData.assessmentType === opt.value ? COLORS.primary : COLORS.textPrimary}>
                            {opt.label}
                          </Typography>
                          {formData.assessmentType === opt.value && (
                            <CheckCircleIcon sx={{ fontSize: 16, color: COLORS.primary, ml: 'auto' }} />
                          )}
                        </Box>
                        <Typography variant="caption" color={COLORS.textMuted}>{opt.desc}</Typography>
                      </Box>
                    ))}
                  </Stack>
                </Box>

                {/* Module */}
                <TextField select label="Module" fullWidth variant="outlined" sx={{ mb: 2.5 }}
                  value={formData.moduleName}
                  InputProps={{ sx: { borderRadius: 2 } }}
                  onChange={e => setFormData({ ...formData, moduleName: e.target.value })}>
                  {batchData?.moduleDetails?.length > 0
                    ? batchData.moduleDetails.map(m => (
                      <MenuItem key={m.id} value={m.moduleName}>{m.moduleName}</MenuItem>
                    ))
                    : <MenuItem disabled>No modules available</MenuItem>}
                </TextField>

                {/* Description */}
                <TextField label="Description" fullWidth multiline rows={3}
                  variant="outlined" sx={{ mb: 2.5 }}
                  placeholder="e.g. Mid-term quiz covering chapters 1–4"
                  value={formData.description}
                  InputProps={{ sx: { borderRadius: 2 } }}
                  onChange={e => setFormData({ ...formData, description: e.target.value })} />

                {/* File upload */}
                {formData.assessmentType === 'FILE' && (
                  <Box sx={{ border: `1.5px dashed ${fileUploaded ? COLORS.success : COLORS.border}`,
                    borderRadius: 2, p: 2.5, mb: 2.5, backgroundColor: fileUploaded ? '#f0fdf4' : '#fff',
                    transition: 'all .2s' }}>
                    <Typography variant="body2" fontWeight={600} color={COLORS.textMuted} mb={1.5}>
                      Upload Assessment File <span style={{ color: COLORS.error }}>*</span>
                    </Typography>
                    <TextField type="file" fullWidth variant="outlined"
                      InputLabelProps={{ shrink: true }}
                      label={fileUploading ? "Uploading…" : fileUploaded ? "File uploaded ✓" : "Choose File"}
                      disabled={fileUploading}
                      InputProps={{ sx: { borderRadius: 2 } }}
                      onChange={e => {
                        const file = e.target.files[0];
                        if (file && file.size > 8 * 1024 * 1024) {
                          e.target.value = "";
                          toast.error("File size must be less than 8MB.");
                        } else handleFileChange(e);
                      }} />
                    {fileUploading && <LinearProgress sx={{ mt: 1.5, borderRadius: 1 }} />}
                    {fileUploaded && (
                      <Box display="flex" alignItems="center" gap={.5} mt={1}>
                        <CheckCircleIcon sx={{ fontSize: 16, color: COLORS.success }} />
                        <Typography variant="caption" color={COLORS.success} fontWeight={600}>
                          File uploaded and ready
                        </Typography>
                      </Box>
                    )}
                    <Typography variant="caption" color={COLORS.textMuted} display="block" mt={1}>
                      Max file size: 8 MB
                    </Typography>
                  </Box>
                )}

                <Stack direction="row" spacing={1.5}>
                  <Button variant="contained" disabled={isSaveDisabled()}
                    onClick={handleSaveAssessment}
                    sx={{ borderRadius: 2, textTransform: 'none', fontWeight: 700, px: 3,
                      background: 'linear-gradient(135deg,#1a56db,#6366f1)',
                      boxShadow: '0 4px 14px rgba(26,86,219,.3)' }}>
                    {formData.assessmentType === 'QUIZ' ? 'Save & Add Questions →' : 'Create Assessment'}
                  </Button>
                  <Button variant="outlined" onClick={handleClose}
                    sx={{ borderRadius: 2, textTransform: 'none', fontWeight: 600,
                      borderColor: COLORS.border, color: COLORS.textMuted }}>
                    Cancel
                  </Button>
                </Stack>
              </Box>
            )}

            {/* ── STEP 2: QUESTIONS ── */}
            {step === 'questions' && (
              <Box>
                {/* Questions bar */}
                <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                  <Box>
                    {questions.length === 0 ? (
                      <Alert severity="warning" icon={<WarningAmberIcon />}
                        sx={{ borderRadius: 2, fontSize: '0.82rem', py: .5 }}>
                        <strong>At least one question is required</strong> before you can save this quiz.
                      </Alert>
                    ) : (
                      <Box display="flex" gap={1} flexWrap="wrap">
                        <Chip label={`${questions.length} question${questions.length !== 1 ? 's' : ''}`}
                          color="primary" size="small" sx={{ fontWeight: 700 }} />
                        <Chip label={`${totalQuestionsMarks} total marks`}
                          size="small"
                          sx={{ backgroundColor: '#fef9c3', color: '#854d0e', fontWeight: 700,
                            border: '1px solid #fde68a' }} />
                      </Box>
                    )}
                  </Box>
                  <Button variant="contained" startIcon={<AddIcon />} onClick={addQuestion}
                    sx={{ borderRadius: 2, textTransform: 'none', fontWeight: 700,
                      background: 'linear-gradient(135deg,#7c3aed,#6366f1)',
                      boxShadow: '0 4px 12px rgba(124,58,237,.3)' }}>
                    Add Question
                  </Button>
                </Box>

                {questions.length === 0 && (
                  <Box textAlign="center" py={6}
                    sx={{ border: `2px dashed ${COLORS.border}`, borderRadius: 3,
                      backgroundColor: '#fff', mb: 2 }}>
                    <QuizIcon sx={{ fontSize: 48, color: COLORS.border, mb: 1 }} />
                    <Typography color={COLORS.textMuted} fontWeight={500} mb={1}>
                      No questions yet
                    </Typography>
                    <Button variant="outlined" startIcon={<AddIcon />} onClick={addQuestion}
                      sx={{ borderRadius: 2, textTransform: 'none', fontWeight: 600 }}>
                      Add First Question
                    </Button>
                  </Box>
                )}

                {questions.map((q, qIdx) => (
                  <QuestionCard
                    key={qIdx}
                    q={q} qIdx={qIdx}
                    onUpdate={updateQuestion}
                    onRemove={removeQuestion}
                    onAddOption={addOption}
                    onRemoveOption={removeOption}
                    onUpdateOption={updateOption}
                    onAddPair={addMatchPair}
                    onRemovePair={removeMatchPair}
                    onUpdatePair={updateMatchPair}
                  />
                ))}

                <Divider sx={{ my: 2 }} />

                <Stack direction="row" spacing={1.5}>
                  <Button variant="contained" color="success"
                    disabled={questions.length === 0}
                    onClick={handleSaveAllQuestions}
                    startIcon={<CheckCircleIcon />}
                    sx={{ borderRadius: 2, textTransform: 'none', fontWeight: 700, px: 3 }}>
                    {questions.length === 0
                      ? 'Add at least 1 question to save'
                      : `Save ${questions.length} Question${questions.length !== 1 ? 's' : ''} ✓`}
                  </Button>
                  <Button variant="outlined" onClick={handleClose}
                    sx={{ borderRadius: 2, textTransform: 'none', fontWeight: 600,
                      borderColor: COLORS.border, color: COLORS.textMuted }}>
                    Cancel
                  </Button>
                </Stack>
              </Box>
            )}
          </Box>
        </Box>
      </Modal>

      {/* ── DELETE CONFIRMATION ───────────────────────────────── */}
      <Dialog open={deleteDialogOpen} onClose={() => setDeleteDialogOpen(false)}
        maxWidth="sm" fullWidth PaperProps={{ sx: { borderRadius: 3 } }}>
        <DialogTitle sx={{ pb: 1 }}>
          <Box display="flex" alignItems="center" gap={1.5}>
            <Avatar sx={{ backgroundColor: '#fee2e2', width: 38, height: 38 }}>
              <DeleteIcon sx={{ color: COLORS.error, fontSize: 20 }} />
            </Avatar>
            <Typography variant="h6" fontWeight={700}>Confirm Delete</Typography>
          </Box>
        </DialogTitle>
        <DialogContent>
          {deleteChecking ? (
            <Box display="flex" alignItems="center" gap={2} py={1}>
              <CircularProgress size={20} />
              <Typography>Checking for student submissions…</Typography>
            </Box>
          ) : deleteError ? (
            <Alert severity="error" icon={<WarningAmberIcon />} sx={{ borderRadius: 2 }}>
              {deleteError}
            </Alert>
          ) : (
            <Box>
              <Typography color={COLORS.textMuted} mb={1}>
                Are you sure you want to permanently delete:
              </Typography>
              <Box sx={{ backgroundColor: '#f8fafc', borderRadius: 2, p: 2,
                border: `1px solid ${COLORS.border}` }}>
                <Typography fontWeight={700} color={COLORS.textPrimary}>
                  "{deleteTarget?.description}"
                </Typography>
                <Typography variant="caption" color={COLORS.textMuted}>
                  {deleteTarget?.assessmentType} · {deleteTarget?.moduleName}
                </Typography>
              </Box>
              <Typography variant="body2" color={COLORS.error} mt={1.5} fontWeight={500}>
                ⚠ This action cannot be undone.
              </Typography>
            </Box>
          )}
        </DialogContent>
        <DialogActions sx={{ p: 2.5, gap: 1 }}>
          <Button onClick={() => setDeleteDialogOpen(false)} variant="outlined"
            sx={{ borderRadius: 2, textTransform: 'none', fontWeight: 600 }}>
            Cancel
          </Button>
          <Button onClick={confirmDelete} variant="contained" color="error"
            disabled={!!deleteError || deleteChecking}
            sx={{ borderRadius: 2, textTransform: 'none', fontWeight: 700 }}>
            Delete Permanently
          </Button>
        </DialogActions>
      </Dialog>

      {/* ── SUB-DIALOGS ──────────────────────────────────────── */}
      <FileEditDialog
        open={fileEditOpen}
        onClose={() => setFileEditOpen(false)}
        assessment={selectedAssessment}
        onSaved={fetchAssessmentData}
      />
      <QuizEditDialog
        open={quizEditOpen}
        onClose={() => setQuizEditOpen(false)}
        assessment={selectedAssessment}
        onSaved={fetchAssessmentData}
      />
      <MCQViewDialog
        open={viewQuizOpen}
        onClose={() => setViewQuizOpen(false)}
        assessment={selectedAssessment}
      />

      <ToastContainer position="bottom-right" autoClose={3000} hideProgressBar
        toastStyle={{ borderRadius: 12, fontSize: '0.85rem' }} />
    </Box>
  );
};

export default App;